{
  "settings" : {
    "calendar" : {
      "calendar_settings" : "Kalendereinstellungen",
      "settings" : "Einstellungen",
      "select_calendar_type" : "Kalendertyp auswählen",
      "add_new_calendar_group" : "Neue Kalendergruppe hinzufügen",
      "add_new_equipment" : "Neue Geräte hinzufügen",
      "new_calendar" : "Neuer Kalender",
      "calendar_group_description" : "Verwende Kalendergruppen, um mehrere Kalender effektiv zu organisieren und zu gruppieren.",
      "group" : "Gruppe",
      "manage_your_calendars_and_groups" : "Verwalte deine Kalender und Gruppen",
      "groups" : "Gruppen",
      "create_group" : "Gruppe erstellen",
      "create_calendar" : "Kalender erstellen",
      "calendar_name" : "Kalendername",
      "group_duration" : "Gruppendauer",
      "calendar_type" : "eintippen",
      "action" : "Aktion",
      "round_robin" : "Wechselnde Zuweisung",
      "event" : "Veranstaltung",
      "group_name" : "Gruppenname",
      "room_name" : "Raumname",
      "group_description" : "Gruppenbeschreibung",
      "calendar_url" : "Kalender-URL",
      "calendars" : "Kalender",
      "date_updated" : "Aktualisierungsdatum",
      "status" : "Status",
      "action_dropdown" : "Dropdown „Aktion“",
      "calendar_list" : "Services im Zusammenhang mit",
      "edit" : "Bearbeiten",
      "duplicate" : "Duplikat",
      "copy_embed_code" : "Einbettungscode kopieren",
      "copy_permanent_link" : "Permanentlink kopieren",
      "copy_new_slug_link" : "Planungslink kopieren",
      "copy_scheduling_link" : "Planungslink kopieren (veraltete Version)",
      "deactivate_calendar" : "Kalender deaktivieren",
      "move_to_group" : "In Gruppe verschieben",
      "delete_calendar" : "Kalender löschen",
      "delete_group" : "Löschen",
      "delete_this_group" : "Diese Gruppe löschen",
      "activate_calendar" : "Kalender aktivieren",
      "duration" : "Dauer",
      "all" : "Alle",
      "draft" : "Entwurf",
      "inactive" : "Inaktiv",
      "active" : "Aktiv",
      "actions" : "Aktivitäten",
      "rearrange_calendars" : "Kalender neu anordnen",
      "deactivate_all_calendars_in_group" : "Aussetzen aller Kalender in Gruppe",
      "activate_all_calendars_in_group" : "Alle Kalender in der Gruppe aktivieren",
      "no_groups_found" : "Deine Suche stimmt mit keiner Kalendergruppe überein.",
      "no_groups_in_location" : "Gruppe Sortieren Sie Ihre Kalender wie Ordner. Kalender zu einer Gruppe hinzufügen und eine Einzelperson teilen Link zur Terminplanung, damit Booker Von mehreren Kalendern auswählt.",
      "no_calendars_found" : "Beginne mit der Verwendung des Kalenders, indem du einen neuen Kalender erstellst.",
      "no_calendars_found_search" : "Deine Suche hat mit keinem Kalender übereingestimmt.",
      "delete_calendar_message" : "Du bist dabei, den Kalender zu löschen. Wenn du auf Löschen klickst, werden auch alle Termine gelöscht.",
      "delete_calendar_message_title" : "Diesen Kalender löschen?",
      "duplicate_calendar_message" : "Du bist dabei, den Kalender zu duplizieren. Dadurch wird ein neuer Kalender mit den gleichen Einstellungen wie der ausgewählte Kalender erstellt.",
      "duplicate_calendar_message_title" : "Diesen Kalender duplizieren?",
      "no_calendars_found_title" : "Keine Kalender gefunden",
      "no_groups_in_location_title" : "Keine Gruppen gefunden",
      "delete_group_confirmation_title" : "Diese Gruppe löschen?",
      "delete_group_confirmation" : "Möchtest du die ausgewählte Gruppe wirklich löschen?",
      "delete_group_confirmation_checkbox_title" : "Verknüpfte Kalender und Termine löschen",
      "delete_group_confirmation_checkbox_description" : "Wenn du diese Option wählst, werden auch die Kalender in dieser Gruppe sowie alle Termine in diesen Kalendern gelöscht.",
      "group_status_message_title" : "{status} Gruppe & jeder Mitglieder Kalender?",
      "calendar_status_message_title" : "Diesen Kalender {status}?",
      "calendar_status_message" : "Du bist dabei, den Kalender zu {status}",
      "group_status_active_message" : "Möchten Sie diese Gruppe wirklich auslösen? Alle Kalender innerhalb der Gruppe werden ebenfalls aktiviert und zur Buchung verfügbar",
      "group_status_inactive_message" : "Möchten Sie diese Gruppe wirklich aussetzen? Alle Kalender innerhalb der Gruppe werden ebenfalls deaktiviert und sind zur Buchung verfügbar",
      "coming_soon" : "Demnächst verfügbar",
      "select" : "Auswählen",
      "15mins" : "15 Min.",
      "cancel" : "Absagen",
      "save" : "Speichern",
      "create" : "Erstellen",
      "select_calendar_group" : "Kalendergruppe auswählen",
      "move_calendar_confirmation" : "Bitte beachte, dass der alte Link nicht mehr funktioniert, sobald du mit der Änderung fortfährst. Bitte bestätige durch Ankreuzen des Kästchens.",
      "previously_called_unassigned" : " (Zuvor als nicht zugewiesen bezeichnet)",
      "scheduling_type" : "Auswählen Kalendertyp",
      "scheduling_type_description" : "Auswählen einen Kalendertyp, um deinen Kalender zu konfigurieren und festzulegen, wie Termine Geplant sind.",
      "service_menu_name" : "Name des Servicemenüs",
      "template" : "Vorlage",
      "select_template" : "Vorlage auswählen",
      "group_url" : "Gruppen-URL",
      "template_description" : "Du hast jetzt die Wahl zwischen den Vorlagen Klassisch oder Neo für die Gruppenansicht",
      "rooms" : "Räume",
      "rooms_name" : "Name",
      "rooms_description" : "Beschreibung",
      "rooms_modal_description" : "Raum hinzufügen oder bearbeiten",
      "rooms_capacity" : "Gesamtkapazität",
      "no_rooms_in_location_title" : "Keine Räume gefunden",
      "no_rooms_in_location" : "An diesem Ort wurden keine Räume gefunden",
      "no_equipments_in_location" : "An diesem Standort wurden keine Geräte gefunden",
      "equipments" : "Geräte",
      "equipment_name" : "Name",
      "equipment_name_search" : "Gerätename",
      "equipment_description" : "Beschreibung",
      "equipment_modal_description" : "Ein Gerät hinzufügen oder bearbeiten",
      "add_equipment" : "Gerät hinzufügen/bearbeiten",
      "add_room" : "Raum hinzufügen/bearbeiten",
      "equipment_quantity" : "Gesamtmenge",
      "equipment_outOfService" : "Menge außer Betrieb",
      "no_equipments_in_location_title" : "Keine Geräte gefunden",
      "delete_this_equipment" : "Dieses Gerät löschen",
      "delete_this_rooms" : "Diesen Raum löschen",
      "delete_equipment_confirmation" : "Bist du sicher, dass du dieses Gerät löschen willst? Dies wird auch aus allen verknüpften Kalendern entfernt.",
      "delete_rooms_confirmation" : "Bist du sicher, dass du diesen Raum löschen willst? Dieser wird auch aus allen verknüpften Kalendern entfernt.",
      "add_new_calendar_equipments" : "Neues Gerät hinzufügen",
      "no_equipments_found" : "Deine Suche hat mit keinem Gerät übereingestimmt.",
      "no_rooms_found" : "Deine Suche hat mit keinem Raum übereingestimmt.",
      "add_new_calendar_rooms" : "Neuen Raum hinzufügen",
      "rooms_disable" : "Raum deaktivieren",
      "equipments_disable" : "Gerät deaktivieren",
      "equipments_activate" : "Gerät aktivieren",
      "rooms_activate" : "Raum aktivieren",
      "create_equipments" : "Gerät erstellen",
      "create_rooms" : "Raum erstellen",
      "select_calendar_rooms_title" : "Kalender auswählen",
      "select_calendar_rooms_description" : "Du kannst mehrere Kalender auswählen, um sie mit Räumen zu verknüpfen",
      "select_calendar_equipments_title" : "Kalender auswählen",
      "select_calendar_equipments_description" : "Du kannst einen Kalender auswählen, der dem Gerät zugeordnet werden soll",
      "disable_equipment_title" : "Gerät {status}",
      "disable_room_title" : "Raum {status}",
      "equipments_status_message" : "Möchtest du dieses Gerät wirklich {status}?",
      "rooms_status_message" : "Möchtest du diesen Raum wirklich {status}?",
      "calendar_resource_disclaimer" : "Dies könnte die Verfügbarkeit in den zugehörigen Servicekalendern beeinflussen.",
      "equipment_disclaimer" : "Hinweis: Wenn du das Gerät später aktivierst, wird es automatisch wieder mit den Kalendern verbunden, mit denen es verknüpft ist",
      "room_disclaimer" : "Hinweis: Wenn du den Raum später aktivierst, wird er automatisch wieder mit den Kalendern verbunden, mit denen er verknüpft ist",
      "equipment_tab_name" : "Geräte",
      "rooms_tab_name" : "Räume",
      "manage_your_rooms" : "Verwalte hier Räume für dein Unternehmen",
      "manage_your_equipments" : "Verwalte hier Geräte für dein Unternehmen",
      "select_service_calendar_description_equipments" : "Du kannst mehrere Servicekalender auswählen, die mit Geräten verknüpft werden sollen",
      "select_service_calendar_description_rooms" : "Du kannst mehrere Servicekalender auswählen, die mit Räumen verknüpft werden sollen",
      "service_menus" : "Servicemenü",
      "manage_your_calendars_groups_and_service_menus" : "Verwalte deine Kalender, Gruppen und dein Servicemenü",
      "new_service_menu" : "Servicemenü erstellen",
      "deactivate_service_menu" : "Servicemenü deaktivieren",
      "delete_service_menu" : "Dieses Servicemenü löschen",
      "delete_service_menu_confirmation" : "Möchtest du dieses Servicemenü wirklich löschen?",
      "service_menu_status_message_title" : "Dieses Servicemenü {status}?",
      "service_menu_status_message" : "Du bist dabei, das Servicemenü zu {status}",
      "no_service_menus_in_location_title" : "Erstelle dein individuelles Servicemenü",
      "add_new_service_menu" : "Neues Servicemenü hinzufügen",
      "no_service_menus_in_location" : "Erstelle zunächst ein neues Servicemenü und füge Gruppen hinzu",
      "no_service_menu_found" : "Kein Servicemenü gefunden",
      "no_service_menu_found_desc" : "Deine Suche hat mit keinem Servicemenü übereingestimmt.",
      "apply" : "Anwenden",
      "troubleshoot_calendar" : "Problembehandlung bei Kalendern",
      "round_robin_booking" : "Round Robin",
      "round_robin_description" : "Verteilt Termine in rotierender Reihenfolge auf die Teammitglieder.",
      "round_robin_example" : "Z. B.: Verkaufsgespräche, Onboarding-Sitzungen.",
      "unassigned_booking" : "Veranstaltungskalender",
      "unassigned_description" : "Für die Planung von physischen Veranstaltungen ohne Zuordnung zu einem Gastgeber.",
      "unassigned_example" : "Z. B.: Konferenzen, öffentliche Seminare, Messen.",
      "event_booking_alert_title" : "Wichtig",
      "event_booking_alert_message" : "Dieser Kalendertyp hat wesentliche Unterschiede",
      "event_booking_know_more" : "Mehr erfahren",
      "event_booking_tooltip_title" : "Wissenswertes:",
      "event_booking_tooltip_content" : "• Dynamische Konferenz-Verknüpfung-Tools werden nicht unterstützt (z. B. Zoom/Google Meet/MS Teams)  \n• Es kann kein Benutzer zugewiesen werden  \n• Vorkommnisse werden via Standard nicht mit dem Kalender eines Benutzers synchronisiert  \n• Nur ein Google-Kalender der Einzelperson kann via externer Synchronisierung synchronisiert werden  \n• Konfliktkalender werden nicht unterstützt",
      "class_booking" : "Kursbuchung",
      "class_booking_description" : "Ein Gastgeber trifft sich mit mehreren Teilnehmern.",
      "class_booking_example" : "Z. B.: Webinare, Gruppenschulungen, Online-Kurse.",
      "collective_booking" : "Sammelbuchung",
      "collective_booking_description" : "Mehrere Gastgeber treffen sich mit einem Teilnehmer.",
      "collective_booking_example" : "Z. B. Panelinterviews, Ausschussbewertungen.",
      "service_booking" : "Servicebuchung",
      "service_booking_description" : "Nahtlose Terminplanung für dienstleistungsorientierte Unternehmen.",
      "service_booking_example" : "Z. B.: Spa-Termine, Reparaturdienste, Beratungen.",
      "personal_booking" : "Persönliche Buchung",
      "personal_booking_description" : "Plant Einzelgespräche mit einem bestimmten Teammitglied.",
      "personal_booking_example" : "Z. B.: Kundentreffen, private Beratungen.",
      "personal" : "Persönlich",
      "explore_more_types" : "Mehr Arten erkunden",
      "no_calendars_added" : "Noch keine Kalender – Sammlung One Up!",
      "no_calendars_added_description" : "Erstellen Sie Ihren ersten Kalender, um mühelos mit dem Zeitplan zu beginnen.",
      "no_groups_added" : "Noch keine Gruppe – Start mit der Organisation!",
      "no_calendars_yet" : "Noch keine Kalender",
      "no_groups_yet" : "Noch keine Gruppe",
      "no_calendars_access" : "Noch keine Kalender wurden erstellt. Sobald ein Kalender erstellt wurde, wird er hier angezeigt. Sie haben keinen Zugriff auf die Erstellung eines Kalenders – bitte kontaktieren Sie Ihren Admin Falls erforderlich.",
      "no_groups_access" : "Keine Gruppe wurde noch konfiguriert. Sobald eine Gruppe erstellt wurde, wird sie hier angezeigt. Sie haben keinen Zugriff auf die Erstellung einer Gruppe – bitte kontaktieren Sie Ihre Admin Falls erforderlich.",
      "no_groups_added_description" : "Verwende Gruppe, um deine Kalender organisiert zu halten. Kalender zu einer Gruppe hinzufügen und eine Einzelperson Gruppe teilen Link zur Terminplanung für Einfach Booking.",
      "group_success_message" : "Gruppe wurde erfolgreich erstellt. Sie können jetzt Kalender in diese Gruppe einbeziehen.",
      "choose_calendars" : "Kalender auswählen",
      "do_it_later" : "Ich machen es später",
      "add_calendars_to_group" : "Kalender zur Gruppe Hinzufügen",
      "select_calendars_to_add" : "Bitte Auswählen jeder der Kalender, die Sie in die Gruppe {name}einbeziehen möchten",
      "add_calendars" : "Kalender(e) Hinzufügen",
      "continue" : "Weiter",
      "conflicting_calendars" : "Kalenderkonflikte",
      "conflicting_calendars_description" : "Die Nachlauf-Kalender sind bereits Teil von Andere Gruppe. Möchten Sie sie in Ihre Neu Gruppe, <b>{name}</b> verschieben?",
      "group_associated_with" : "Derzeit Gruppe",
      "move_calendar_consent" : "Ich aktiviere diese Kalender an die Neu Gruppe verschieben.",
      "calendars_moved_successfully" : "Jeder der ausgewählten Kalender wurden erfolgreich nach {name} verschoben.",
      "new_group" : "Neu Gruppe",
      "back" : "Zurück",
      "share_otl" : "Teilen Sie Ihre Verfügbarkeit jeder Datum mit einem eindeutigen Link , der ab einem späteren Zeitpunkt eine Buchung läuft und den Zugriff gewährleistet.",
      "copied_to_clipboard" : "In die Zwischenablage kopiert",
      "generate_link" : "Erzeugen Neu Link",
      "generate_link_error" : "Es konnte kein einmaliger Link generiert werden. Bitte erneut versuchen",
      "share_schedule_link" : " Der Link zur Terminplanung wird über den Slug bestimmt. Ändern Sie den Slug, und der Link zur Terminplanung passt sich automatisch an die Änderung an.",
      "share_permanent_link" : "Ideal für Funnel, Website-Weiterleitungen oder Anzeigen: Der permanente Link bleibt konstant derselbe und wird von Slug-Änderungen nicht beeinflusst.",
      "copy" : "Kopieren",
      "share_embed_code" : "Standort diesen Code in deinem HTML an der Stelle, an der dein {embedType} Widget erscheinen soll.",
      "scheduling_link" : "Link zur Terminplanung",
      "permanent_link" : "Permanenter Link",
      "one_time_link" : "Ein Link",
      "embed_code" : "Einbettungscode",
      "loading" : "Wird Laden...",
      "share_group" : "Gruppe teilen",
      "edit_group" : "Gruppe Bearbeiten",
      "more_options" : "Mehr Optionen",
      "share_calendar" : "Kalender teilen",
      "edit_calendar" : "Kalender Bearbeiten",
      "troubleshoot_calendar_link" : "Fehlerbehebung bei Kalendern",
      "calendar_config_success" : "Sie haben Ihren persönlichen/Gruppenkalender erfolgreich konfiguriert",
      "close" : " Schließen",
      "added_calendars" : "Hinzugefügte Kalender",
      "select_calendars" : "Kalender Auswählen",
      "settings_confirmation" : "Um fortfahren zu können, bestätigen Sie bitte diese Dynamisch.",
      "consent_checkbox_title" : "Ich verstehen und akzeptiere diese Dynamisch",
      "confirm" : "Bestätigen",
      "create_group_access_disabled" : "Sie haben keine Autorisierung, um eine Gruppe zu erstellen. Kontaktiere deinen Admin , um den Zugriff zu erfahren.",
      "create_calendar_access_disabled" : "Sie haben keine Autorisierung, um einen Kalender zu erstellen. Kontaktiere deinen Admin , um den Zugriff zu erfahren.",
      "preview_booking_widget" : "Vorschau des Booking Widget",
      "share_service_menu" : "Servicemenü teilen",
      "back_message" : "Zurück zur Liste",
      "service_calendars" : "Servicekalender",
      "owned_by" : "Im Eigentum Via",
      "owned_by_anyone" : "Jeder",
      "owned_by_me" : "Ich",
      "all_groups" : "jeder Gruppe",
      "all_calendars" : "jeder Kalender",
      "not_grouped" : "Nicht gruppiert",
      "delete_group_desc" : "Möchten Sie diese Gruppe wirklich löschen? Dadurch werden auch alle Kalendermitglieder mit dieser Gruppe gelöscht.",
      "calendar_listing_title" : "Kalendereintrag",
      "calendar_group_name" : "Name / Gruppe",
      "success" : "Erfolg",
      "my_calendar" : "Mein Kalender"
    },
    "preferences" : {
      "preferences" : "Einstellungen",
      "my_preferences" : "Meine Einstellung",
      "account_preferences" : "Kontoeinstellungen",
      "user_preferences" : "Benutzereinstellungen",
      "set_preferences" : "Lege deine Einstellungen für dein Konto fest.",
      "scheduling_options" : "Optionen für die Terminplanung",
      "meeting_location" : "Besprechungsort",
      "zoom" : "Zoom",
      "save_preferences" : "Einstellungen speichern",
      "in_app_preferences" : "In App-Einstellungen",
      "set_start_day" : "Lege Einstellungen wie den Starttag für die App fest",
      "view_options" : "Optionen anzeigen",
      "services" : "Dienste",
      "feature_toggle_aria" : "Funktionsumschaltung",
      "week_starts_on" : "Wochenbeginn",
      "sunday" : "Sonntag",
      "widget_preferences" : "Widget-Einstellungen",
      "set_widget_language" : "Einstellungen wie Sprache für Widget festlegen",
      "language_and_region" : "Sprache und Region",
      "language" : "Sprache",
      "english" : "Englisch",
      "time_format" : "Zeitformat",
      "time_format_value" : "13:30 UHR",
      "monday" : "Montag",
      "custom_meeting_location" : "Benutzerdefinierter Besprechungsort",
      "view_appointments_in_1" : "Termine anzeigen in",
      "timezone_uses_details_1" : "Wir werden diese Zeitzone verwenden, um die Terminzeiten in der gesamten App und in deinen terminbezogenen E-Mails anzuzeigen – nur für dich. Es hat keine Auswirkungen auf Ihre Verfügbarkeit oder darauf, wie andere bei Ihnen buchen.",
      "business_timezones_1" : "Zeitzone des Unternehmens",
      "business_timezones_tooltip_1" : "Hinweis: Wenn Sie diese Option wählen, wird sichergestellt, dass Ihre Anzeigepräferenz mit der ausgewählten Unternehmenszeitzone übereinstimmt. Falls sich die Zeitzone des Unternehmens ändert, wird Ihre Zeitzone automatisch angepasst.",
      "recommended_timezones" : "Empfohlene Zeitzonen",
      "all_timezones" : "Alle Zeitzonen"
    },
    "availability" : {
      "availability" : "Verfügbarkeit",
      "my_availability" : "Meine Verfügbarkeit",
      "my_availability_and_booking_rules" : "Verfügbarkeit und Buchungsrichtlinien",
      "my_availability_and_booking_rules_description" : "Konfiguration Sie Ihre Verfügbarkeit und Sammlung Sie, wie und Wenn dieser Kalender Buchungen akzeptiert – einschließlich Konferenzenintervallen, Limits und Anderen Planungseinstellungen. ",
      "account_availability" : "Kontoverfügbarkeit",
      "timezone" : "Zeitzone",
      "working_hours" : "Arbeitszeiten",
      "set_recurring_hours" : "Lege deine wiederkehrenden Arbeitszeiten für Besprechungen fest",
      "select_one" : "Eine Option auswählen",
      "sunday" : "Sonntag",
      "monday" : "Montag",
      "tuesday" : "Dienstag",
      "wednesday" : "Mittwoch",
      "thursday" : "Donnerstag",
      "friday" : "Freitag",
      "saturday" : "Samstag",
      "widget_preferences" : "Widget-Einstellungen",
      "set_widget_language" : "Einstellungen wie Sprache für Widget festlegen",
      "language_and_region" : "Sprache und Region",
      "language" : "Sprache",
      "english" : "Englisch",
      "copy_to_all" : "Kopie an alle",
      "save_availability" : "Verfügbarkeit speichern",
      "add_time" : "Zeit hinzufügen",
      "to" : "Zu",
      "select_time" : "Zeit auswählen",
      "add_user" : "Benutzer Hinzufügen",
      "accessRestricted" : {
        "header" : "Zugriff Privat",
        "message" : "Sie sind nicht Teil dieses Kontos. Um Zugriff zu erhalten, ziehen Sie sich in dieses Konto über Agentur Einstellungen > Gruppe > Bearbeiten Gruppe Mitglieder ein undzuweisen Sie das Konto unter „Role & Berechtigungen“",
        "contact_admin" : "Diese Seite ist nur Öffentlich für Administratoren. Bitte kontaktiere deinen Admin, um Hilfe zu erhalten.",
        "button_text" : "Gehen Sie zu Agentur Einstellungen"
      },
      "schedule" : {
        "edit_schedule" : "Zeitplan bearbeiten",
        "schedule_name" : "Name des Zeitplans",
        "schedule_name_required" : "Der Name des Zeitplans ist erforderlich",
        "timezone" : "Zeitzone",
        "timezone_placeholder" : "Option auswählen",
        "start_time" : "Startzeit",
        "end_time" : "Endzeit",
        "add_availability_hour" : "Verfügbarkeit Stunde hinzufügen",
        "remove_availability_hour" : "Verfügbarkeit Stunde entfernen",
        "unavailable" : "Nicht verfügbar",
        "schedule_created" : "Zeitplan erfolgreich erstellt",
        "schedule_updated" : "Zeitplan erfolgreich aktualisiert",
        "calendars_selected" : "{count} Kalender",
        "calendars_selected_multiple" : "{count} Kalender",
        "select_users_placeholder" : "Benutzer suchen",
        "edit_default_schedule" : "Diesen Zeitplan bearbeiten",
        "customize_event_type_schedule" : "Zeitplan nur für diesen Kalender anpassen",
        "multi_user_description" : "<b>{count} Benutzer</b> sind ausgewählt, aktualisieren Sie ihre Verfügbarkeit für <b>{calendar}</b>",
        "selected_calendar" : "ausgewählter Kalender",
        "edit_schedule_alert" : "Hier vorgenommene Aktualisierungen werden angewendet auf",
        "schedule" : "Zeitplan",
        "no_availability" : "Keine Verfügbarkeit",
        "date_specific_hours_show_more" : "mehr",
        "date_specific_hours_show_less" : "weniger",
        "date_specific_hours_recurring_meetings_enabled" : "Datumsspezifische Stunden können nicht hinzugefügt werden, da dieser Zeitplan mit einem Kalender verknüpft ist, in dem wiederkehrende Meetings aktiviert sind. Um weiterzukommen, deaktivieren Sie bitte wiederkehrende Meetings.",
        "recurring_incompatible_with_date_hours" : "Wiederkehrende Besprechungen können nicht aktiviert werden, da der Zeitplan des Benutzers datumsspezifische Stunden enthält, die nicht kompatibel sind.",
        "incompatible_schedule_with_recurring" : "{user} Zeitplan enthält datumsspezifische Stunden, die mit wiederkehrenden Meetings nicht kompatibel sind.",
        "incompatible_schedule_with_recurring_calendar" : "Der Zeitplan enthält stundenweise Angaben zu bestimmten Daten, die mit wiederkehrenden Besprechungen nicht vereinbar sind.",
        "recurring_meetings_enabled_multi_user" : "Für wiederkehrende Besprechungen ist nur ein zugewiesenes Teammitglied erforderlich, und ihr Zeitplan darf keine datumsspezifischen Stunden enthalten.",
        "weekdays" : "Wochentage, {timeRange}",
        "weekdays_hours_vary" : "Wochentage, Öffnungszeiten variieren",
        "weekend" : "Wochenende, {timeRange}",
        "weekend_hours_vary" : "Wochenende, Öffnungszeiten variieren",
        "days_hours_vary" : "{days}, Stunden variieren",
        "date_specific_hours_tab_name" : "Datumsspezifische Uhrzeiten",
        "date_specific_hours" : "{count} datumsspezifische Stunden",
        "date_specific_hours_1" : "1 datumsspezifische Stunde",
        "weekly_hours" : "Wöchentliche Stunden",
        "custom_schedule" : "Benutzerdefinierter Zeitplan",
        "select_schedule" : "Wählen Sie einen Zeitplan aus",
        "no_schedules_found" : "Keine Zeitpläne gefunden",
        "untitled" : "Unbenannt",
        "error_updating_schedules" : "Fehler beim Aktualisieren von Zeitplänen",
        "daily" : "Täglich",
        "weekly" : "Wöchentlich",
        "monthly" : "Monatlich",
        "custom" : "Benutzerdefiniert",
        "this_is_required" : "Dies ist erforderlich",
        "search" : "Suchen",
        "edit_hours" : "Stunden bearbeiten",
        "schedule_name_duplicate" : "Ein Zeitplan mit diesem Namen existiert bereits",
        "delete_schedule_title" : "Zeitplan von '{scheduleName}' löschen?",
        "delete_schedule_description" : "Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie fortfahren möchten?",
        "delete_schedule_negative_text" : "Abbrechen",
        "delete_schedule_positive_text" : "Ja, löschen",
        "active_on" : "Aktiviert",
        "weekly_working_hours" : "Wöchentliche Arbeitszeiten",
        "weekly_working_hours_subtext" : "Wählen Sie die Tage und Zeiten aus, zu denen Sie arbeiten",
        "copy_availability_hour" : "Kopieren Verfügbarkeit Zeit",
        "mins" : "Minuten",
        "hours" : "Stunden"
      }
    },
    "connections" : {
      "connections" : "Verbindungen",
      "connect" : "verbinden",
      "conferencing" : "Konferenzen",
      "my_connections" : "Meine Verbindungen",
      "account_connections" : "Kontoverbindungen",
      "connection_preferences" : "Verbindungseinstellungen",
      "manage_calendars_conferencing_channels" : "Kalender und Konferenzkanäle verwalten",
      "main_integration_calendar" : "Hauptintegrationkalender",
      "event_integration_calendar" : "Ereignisse, die in einem Systemkalender erstellt werden, an dem du beteiligt bist, werden auch in diesem integrierten Kalender erstellt",
      "2way_sync" : "2-Wege-Synchronisierung: Systemereignisse aus Ereignissen erstellen, die im integrierten Hauptkalender gebucht wurden",
      "calendars" : "Kalender",
      "google" : "Google",
      "outlook" : "Outlook",
      "check_for_conflicts" : "Auf Konflikte prüfen",
      "choose_accounts_to_connect" : "Auswählen, welche Konten du verbinden möchtest",
      "payments" : "Zahlungen",
      "stripe" : "Stripe",
      "ads" : "Anzeigen",
      "local_service_ads" : "Lokale Serviceanzeigen",
      "fire_workflow" : "Workflow-Trigger für über 2-Wege-Synchronisierung gebuchte Ereignisse auslösen",
      "connect_google_outlook" : "Google/Outlook/iCloud-Konto verbinden, um den Hauptkalender auswählen zu können.",
      "execute_automation" : "Automatisierung ausführen",
      "save" : "Speichern",
      "lsa" : "Lokale Serviceanzeigen",
      "no_write_access" : "Du hast keinen Schreibzugriff auf diesen Kalender",
      "connection_remove_confirmation" : "Du bist dabei, diese Integration zu entfernen",
      "active" : "Aktiv",
      "icloud" : {
        "title" : "iCloud-Integration",
        "description" : "Zum Verbinden deines Kontos sind eine Zwei-Faktor-Authentifizierung und ein app-spezifisches Passwort erforderlich.",
        "email" : "iCloud E-Mail-Adresse",
        "password" : "iCloud Kennwort",
        "connect" : "Verbinden",
        "cancel" : "Absagen"
      }
    }
  },
  "appointment_modal" : {
    "select_a_contact" : "Kontakt auswählen",
    "start_time" : "Startzeit",
    "unassigned" : "Nicht zugewiesen",
    "end_time" : "Endzeit",
    "search_by_name_email_phone_or_company" : "Suche nach Namen, E-Mail, Telefon oder Firma",
    "add_new" : "Neu hinzufügen",
    "pick_from_available_contacts" : "Oder aus den verfügbaren Kontakten wählen",
    "book_appointment" : "Termin buchen",
    "add_blocked_off_time" : "Blockierte Zeit hinzufügen",
    "recommended_timezones" : "Empfohlene Zeitzonen",
    "all_timezones" : "Alle Zeitzonen",
    "calendar" : "Kalender",
    "repeat" : "Wiederholen",
    "date_and_time" : "Datum und Uhrzeit",
    "close" : "Schließen",
    "team_member" : "Teammitglied",
    "recurring_booking" : "Wiederkehrende Buchung",
    "one_slot_booking" : "Buchung für ein Zeitfenster",
    "event_type" : "Veranstaltungstyp",
    "occurrences_booked" : "Veranstaltungen werden gebucht",
    "repeats" : "Wiederholungen",
    "booking_details" : "Buchungsdetails",
    "showing_slots_in_this_timezone" : "Zeitfenster in dieser Zeitzone werden angezeigt:",
    "update_contact_tz" : "Auch die Zeitzone des Kontakts aktualisieren auf",
    "date" : "Datum",
    "slot" : "Zeitfenster",
    "calendar_default" : "Kalenderstandard",
    "custom" : "Benutzerdefiniert",
    "meeting_notes" : "(z. B.) Sitzungsnotizen für unseren bevorstehenden Termin",
    "out_of_office" : "(z. B.) Für eine Woche nicht im Büro!",
    "standard" : "Standard",
    "appointment_title" : "Titel des Termins",
    "event_title" : "Titel der Veranstaltung",
    "appt_with_bob" : "(z. B.) Termin mit Bernd",
    "vacation" : "(z. B.) Urlaub",
    "show_notes" : "Notizen anzeigen",
    "hide_notes" : "Notizen ausblenden",
    "additional_preferences" : "Zusätzliche Präferenzen",
    "meeting_location" : "Treffpunkt",
    "appointment_status" : "Terminstatus",
    "appt_description" : "Beschreibung des Termins",
    "recurring_details" : "Wiederkehrende Details",
    "event_description" : "Beschreibung der Veranstaltung",
    "in_contact_timezone" : "In der Zeitzone des Kontakts",
    "vacation_message" : "Urlaub geplant? Auszeit geplant? Blockiere die Zeit in deinem Kalender, um Kunden daran zu hindern, Termine zu buchen (bestehende Termine bleiben weiterhin in deinem Kalender gespeichert).",
    "contact" : "Kontakt",
    "delete" : "Löschen",
    "cancel" : "Absagen",
    "back" : "Zurück",
    "pick_available_contacts" : "Oder wähle aus den verfügbaren Kontakten",
    "no_contacts_found" : "Keine Kontakte gefunden",
    "found" : "gefunden",
    "select_one" : "Einen auswählen",
    "tz_tooltip" : "Dies ist nur von Bedeutung, wenn du benutzerdefinierte Werte, wie z. B. termin_start_zeit termin_end_zeit termin_zeitzone usw., in deiner ausgehenden Kommunikation mit deinen Kunden verwendest. Dabei werden die vorgenannten Angaben einfach in die jeweilige Ortszeit umgerechnet.",
    "meeting_location_tooltip" : "Der Besprechungsort wird wie im Kalender konfiguriert festgelegt.",
    "appt_meeting_location_tooltip" : "Der Benutzer kann den Besprechungsort terminspezifisch festlegen.",
    "gmeet_tooltip" : "Bitte stelle sicher, dass das jeweilige Teammitglied einen Google-Kalender als primären Kalender festgelegt hat",
    "zoom_tooltip" : "Bitte stelle sicher, dass das jeweilige Teammitglied Zoom integriert hat",
    "enter_meeting_location" : "Besprechungs-Ort eingeben",
    "save_appointment" : "Termin speichern",
    "save_event" : "Veranstaltung speichern",
    "search_contacts" : "Suche nach Namen, E-Mail, Telefon oder Firma",
    "recurring_slots" : "{recurringSlotsLength}/{count}",
    "custom_timezone" : "Benutzerdefinierte Zeitzone",
    "system_timezone" : "Zeitzone des Systems",
    "contact_timezone" : "Zeitzone des Kontakts",
    "account_timezone" : "Zeitzone des Kontos",
    "an_error_occurred" : "Es ist ein Fehler aufgetreten"
  },
  "popup" : {
    "calendar" : "Kalender",
    "appointment_owner" : "Termin-Owner",
    "source" : "Quelle",
    "booked_by" : "Gebucht von",
    "view_activity_log" : "Aktivitätsprotokoll anzeigen",
    "status" : "Status",
    "cancel_appointment" : "Termin absagen",
    "cancel_all" : "Alle absagen",
    "google_event" : "Google-Ereignis",
    "outlook_event" : "Outlook-Ereignis",
    "blocked_slot" : "Blockiertes Zeitfenster",
    "appointment" : "Termin",
    "confirmed" : "Bestätigt",
    "unconfirmed" : "Unbestätigt",
    "cancelled" : "Abgesagt",
    "showed" : "Erschienen",
    "no_show" : "Nicht erschienen",
    "invalid" : "Ungültig",
    "more" : "Mehr",
    "less" : "Weniger",
    "edit" : "Bearbeiten",
    "reschedule_all" : "Alle verschieben",
    "guests" : "Gast/Gäste",
    "guest_count" : "Anzahl Gast/Gäste"
  },
  "create_calendar" : {
    "calendar_name" : "Kalendername",
    "calendar_logo" : "Kalenderlogo",
    "select_team_member" : "Teammitglieder auswählen",
    "select_single_team_member" : "Teammitglied auswählen",
    "eg_outbound_reach" : "(z. B.) Ausgehende Reichweite",
    "description" : "Beschreibung",
    "amount" : "Betrag",
    "description_placeholder" : "Beschreibung eingeben",
    "meeting_duration" : "Dauer der Besprechung",
    "meeting_location" : "Besprechungsort",
    "seats_per_class" : "Plätze pro Kurs",
    "group" : "Gruppe",
    "custom_url" : "Benutzerdefinierte URL",
    "meeting_invite_title" : "Titel der Besprechungseinladung",
    "event_color" : "Ereignisfarbe",
    "availability_type" : "Verfügbarkeitstyp",
    "new_calendar" : "Neuer Kalender",
    "add_description" : "Beschreibung hinzufügen",
    "remove_description" : "Beschreibung entfernen",
    "booking_availability" : "Buchungsverfügbarkeit",
    "slug_tooltip" : "Passe die URLdes Booking Widget an",
    "meeting_location_tooltip" : "Besprechungs-Links werden in Kalenderereignissen als „Besprechungs-Ort“ angezeigt und ermöglichen es dir, Dinge wie Zoom-Links für das Ereignis hinzuzufügen.",
    "advanced_settings" : "Erweiterte Einstellungen",
    "show_more_schedule" : "Mehr anzeigen",
    "show_more_helper_text" : "Um Ihre Unternehmensstunden weiter anzupassen, gehen Sie bitte zu den erweiterten Einstellungen",
    "reschedule_preference" : "Bevorzugte Terminverschiebung",
    "reschedule_preference_subtext" : "Falls ein {contactLabel} einen Termin verschiebt:",
    "reassign_through_round_robin" : "Neuzuweisung durch Round Robin",
    "keep_same_assinged_user" : "Den gleichen Termin-Owner beibehalten",
    "new_appointment_preference" : "Neue Terminpräferenz",
    "new_appointment_preference_text" : "Immer mit dem zugewiesenen Benutzer von {contactLabel} buchen",
    "new_appointment_preference_subtext" : "Buche neue Termine mit dem {contactLabel} zugewiesenen Benutzer, anstatt die Round-Robin-Planung zu verwenden.",
    "cancel" : "Absagen",
    "confirm" : "Bestätigen",
    "service_calendar_name" : "Servicename",
    "service_logo" : "Servicelogo",
    "service_select_team_member" : "Mitarbeiter auswählen",
    "service_duration" : "Servicedauer",
    "appointment_invite_title" : "Titel der Termineinladung",
    "payment_placeholder" : "Gib eine Beschreibung ein, die dem Benutzer angezeigt wird, um ihn über die Zahlung zu informieren",
    "deposit_amount" : "Einzahlungsbetrag",
    "collect_deposit_amount" : "Teilzahlung akzeptieren",
    "percentage" : "Prozentsatz",
    "total_amount" : "Gesamtbetrag",
    "enter_meeting_location" : "Besprechungsort eingeben",
    "accept_payments" : "Zahlungen akzeptieren",
    "aria" : {
      "should_accept_payment" : "Sollte Zahlung akzeptieren"
    },
    "calendar_name_tooltip" : "Kalendername, der im Booking Widget angezeigt werden soll",
    "booking_availability_tooltip" : "Erfassung der Tage und Stunden, in denen Buchungen vorgenommen werden können. Dies sind Ihre Standard wöchentlichen Geschäft Stunde Erschienen an Benutzer, wenn Sie ein Zeitfenster auswählen",
    "select_team_member_tooltip" : "Auswählen der Gruppe Mitglieder, die diese Konferenzen annehmen möchten",
    "seats_per_class_tooltip" : "Sammlung des Max.. Nummer von Benutzern, die diese Klasse buchen dürfen. Sobald jeder Plätze gefüllt ist, ist das Zeitfenster nicht mehr für Buchungen verfügbar",
    "meeting_color" : "Konferenzen Farbe",
    "meeting_duration_tooltip" : "Dies legt die Länge deiner Konferenzen fest und bestimmt, wie lange sie dauern wird"
  },
  "calendar_advanced" : {
    "general" : {
      "quick_tip" : "Schneller Tipp",
      "timezone_change_tip" : "Zeitzonen können jederzeit unter Zeitzoneneinstellungen geändert werden",
      "save" : "Speichern",
      "close" : "Schließen",
      "meeting_details" : "Besprechungsdetails",
      "availability" : "Verfügbarkeit",
      "forms_and_payment" : "Formulare und Zahlung",
      "notifications_and_additional_options" : "Benachrichtigungen und zusätzliche Optionen",
      "connections" : "Verbindungen",
      "customizations" : "Anpassungen",
      "create" : "Erstellen",
      "edit" : "Bearbeiten",
      "equipments" : "Räume und Geräte",
      "service_details" : "Servicedetails",
      "saving_changes" : "Nur eine Minute – Speichern Sie das neueste Dynamisch...",
      "calendar_id": "Kalender-ID",
      "saveCalendarSuccess": "Kalender erfolgreich gespeichert"
    },
    "meeting_details" : {
      "meeting_location" : "Besprechungsort",
      "enter_meeting_location" : "Besprechungsort eingeben",
      "click_to_upload" : "Zum Hochladen klicken",
      "square" : "Quadrat",
      "circle" : "Kreis",
      "remove_logo" : "Logo entfernen",
      "meeting_invite_title_tooltip" : "Dies ist der Titel für die Kalenderkonferenzen, die Erschienen in Ihrer Termine Listenansicht, Kalenderansicht und Kalender von Drittanbietern",
      "event_color_tooltip" : "Wähle eine Farbe für dieses Buchungsereignis. Farben werden mit Terminen in Google Kalender synchronisiert.",
      "enter_a_name" : "Bitte gib einen Namen ein",
      "enter_an_event_title" : "Bitte gib einen Veranstaltungstitel ein",
      "high_priority" : "Hohe Priorität",
      "medium_priority" : "Mittlere Priorität",
      "low_priority" : "Niedrige Priorität",
      "priority" : "Priorität",
      "custom" : "Benutzerdefiniert",
      "zoom_not_added" : "Der Benutzer hat sein Zoom-Konto noch nicht verbunden",
      "opt_avail" : "Für Verfügbarkeit optimieren",
      "opt_equal" : "Für eine gleichmäßige Verteilung optimieren",
      "team_members" : "Teammitglieder auswählen",
      "team_members_location" : "Auswählen Gruppe Mitglieder & Zuweisen Konferenzen Standort",
      "team_member" : "Teammitglied auswählen",
      "team_member_location" : "Auswählen Gruppe Mitglieder & Zuweisen Konferenzen Standort",
      "meeting_location_required" : "Besprechungsort ist erforderlich",
      "meeting_details" : "Besprechungsdetails",
      "meeting_details_description" : "Dies sind die Details, die auf der Kalenderlistenseite angezeigt werden.",
      "or_drag_and_drop" : "oder ziehen und ablegen",
      "service_details" : "Servicedetails",
      "team_member_disabled_recurring_tooltip" : "Bei wiederkehrenden Besprechungen ist nur ein Teammitglied zugelassen. Um mehrere Teammitglieder hinzuzufügen, deaktiviere wiederkehrende Meetings.",
      "team_member_disabled_class_booking_tooltip" : "Es kann nur ein Teammitglied zu einem Kursbuchungskalender hinzugefügt werden",
      "advanced_settings" : "Erweiterte Einstellungen",
      "enable_contact_assigned_to_setting" : "Um diese Einstellung zu aktivieren, muss das Formular an erster Stelle in der Widget-Reihenfolge stehen. Bitte ordne die Widget-Reihenfolge auf der Registerkarte „Formulare und Zahlung“ neu an.",
      "reschedule_preference_setting_tooltip" : "Wähle aus, wem der Termin zugewiesen werden soll, wenn ein {contactLabel} über das Booking Widget einen neuen Termin bucht.",
      "appointment_preference_tooltip" : "Wähle aus, ob neue Termine immer mit dem zugewiesenen Benutzer des {contactLabel} gebucht werden sollen. Falls einem {contactLabel} ein Benutzer zugewiesen ist, wird diesem Benutzer die Präferenz gegeben; andernfalls erfolgt die Zuweisung im Round-Robin-Verfahren. Tipp: Deaktiviere „Mitarbeiterauswahl zulassen“, um zu verhindern, dass Buchende den Mitarbeiter im Buchungs-Widget ändern.",
      "add_location" : "Ort hinzufügen",
      "multiple_locations_neo" : "Mehrere Konferenzen Anschrift werden nur über das Neo Widget unterstützt.",
      "make_owner" : "Zum Owner machen",
      "only_one_team_member" : "Beim Hinzufügen mehrerer Orte ist nur ein Teammitglied erlaubt.",
      "ask_the_booker_error_message" : "Ort „Den Buchenden fragen“ existiert bereits",
      "enter_location" : "Ortwert eingeben",
      "enter_display_label" : "Anzeigebeschriftung eingeben",
      "add_display_label" : "Anzeigebeschriftung hinzufügen",
      "multiple_location_support_message" : "Mehrere Konferenzen Anschrift werden nur über das Neo Widget unterstützt.",
      "only_one_team_member_personal_calendar" : "Bei der persönlichen Buchung ist nur ein Teammitglied erlaubt. ",
      "ms_teams_not_added" : "Der Benutzer hat sein Microsoft Teams-Konto noch nicht verbunden",
      "enable_new_appt_preference" : "Neu Termin Präferenz aktivieren",
      "enable_new_appt_preference_desc" : "Das Aktivieren von „<b>Buche immer über den {contactLabel} zugewiesenen Benutzer</b>“ legt das <b>Formular</b> automatisch als ersten Schritt in der Reihenfolge der Widgets fest.",
      "location_exists_toast" : "Konferenzen Standort bereits hinzugefügt",
      "not_supported_with_multiple_team_members" : "Nicht unterstützt bei mehreren Gruppe-mitgliedern",
      "not_supported_personal_calendar" : "in persönlichen Kalender nicht unterstützt",
      "not_supported_class_booking" : "Nicht unterstützt in der Klasse Servicekalender",
      "not_supported_collective_booking" : "in GEMEINSAM-Kalender nicht unterstützt",
      "not_supported_service_booking" : "in Servicekalender nicht unterstützt",
      "not_supported_round_robin" : "in Round Robin -Kalender nicht unterstützt",
      "not_supported_event" : "in Veranstaltungskalender nicht unterstützt",
      "calendar_logo_tooltip" : "Auswählen ein Logo , um an dem Booking Widget Erschienen zu werden",
      "calendar_name_tooltip" : "Kalendername, der im Booking Widget angezeigt werden soll",
      "description_tooltip" : "Beschreibe, was der Kalender ist, der im Booking Widget angezeigt werden soll",
      "group_tooltip" : "Sie können diesen Kalender einer Gruppe (Falls Erstellt) zuweisen. Benutzer Zugriff auf den Gruppe Link kann Kalender in dieser Gruppe durchsuchen und buchen",
      "custom_url_tooltip" : "Passe die URLdes Booking Widget an",
      "meeting_color_tooltip" : "Auswählen eine Farbe für diese Buchungsveranstaltung. Farben werden mit Veranstaltungen in Google-Kalender synchronisiert",
      "add_display_label_tooltip" : "Um den Standort zu verdecken, sind mehrere Standortoptionen verfügbar",
      "meeting_location_tooltip" : "Auswählen wie Oder, wo die Konferenzen Standort werden werden",
      "team_members_location_tooltip" : "Auswählen der Gruppe Mitglieder, die diese Konferenzen annehmen möchten",
      "meeting_distribution" : "Konferenzen Lieferung",
      "meeting_distribution_tooltip" : "Auswählen, wie Termine auf Ihre Ausgewählte Gruppe Mitglieder verteilt werden – basierend auf einer Verfügbarkeit oder gleicher Lieferung",
      "opt_avail_tooltip" : "Weise Besprechungen den Gruppe-mitgliedern zu, die am ausgewählten Datum verfügbar sind, unabhängig von vorherigen Buchungen. Maximale Auslastung des geöffneten Zeitfensters und Buchungsverlauf",
      "opt_equal_tooltip" : "Veröffentlichen Besprechungen Gleich unter jeder Gruppe Mitglieder Via Tracking vorheriger Buchungen. Lege den Vorrang vor der Verfügbarkeit fest",
      "priority_tooltip" : "Sammlung der Präferenz Gleich für die Zuweisung von Besprechungen, wenn mehrere Gruppe-mitglieder verfügbar sind. Mitglieder mit größerer Priorität werden zuerst bei Buchungen, Folgen Via Mittel und Mitglieder mit geringer Priorität berücksichtigt",
      "contact_routing_preference" : "Präferenz Kontakt",
      "contact_routing_preference_tooltip" : "Definiere, wie neue und wiederkehrende {contactsLabel} den Teammitgliedern zugewiesen werden – entweder per Round Robin oder ihrem ursprünglichen Eigentümer",
      "team_members_location_owner_tooltip" : "Der PRIMÄRE Benutzer, dem die Konferenzen gehört und den endgültigen Konferenzen-standort bereitstellt",
      "owner" : "Eigentümer",
      "upload_from_system" : "Vom System hochladen",
      "choose_from_media_storage" : "Aus Medienspeicher auswählen",
      "only_one_team_member_allowed" : "Nur ein Gruppenmitglied ist erlaubt.",
      "at_least_two_team_members_required" : "Es sind mindestens 2 Teammitglieder erforderlich.",
      "at_least_one_team_member_required" : "Mindestens ein Teammitglied ist erforderlich."
    },
    "availability" : {
      "my_availability" : "Meine Verfügbarkeit",
      "set_availability" : "Stelle hier deine Verfügbarkeit für den Kalender ein.",
      "standard" : "Standard",
      "custom" : "Benutzerdefiniert",
      "to" : "An",
      "copy_to_all" : "Kopie an alle",
      "add_time" : "Zeit hinzufügen",
      "recurring_meeting" : "Wiederkehrendes Treffen",
      "recurring_info" : "Nur ein Benutzer pro Kalender für wiederkehrende Buchungen",
      "repeat" : "Wiederholen",
      "times_to_repeat" : "Zeiten zum Wiederholen",
      "slots_unavailable" : "Wenn Zeitfenster nicht verfügbar sind?",
      "overlap_status" : "Terminstatus bei Terminüberschneidungen ",
      "meeting_interval" : "Besprechungsintervall",
      "meeting_duration" : "Dauer der Besprechung",
      "minimum_scheduling" : "Mindestterminvorgabe",
      "date_range" : "Datumsbereich",
      "maximum_bookings_per_day" : "Maximale Buchungen pro Tag",
      "maximum_bookings_per_slot" : "Maximale Buchungen pro Zeitfenster",
      "maximum_bookings_per_slot_per_user" : "Maximale Buchungen pro Zeitfenster (pro Benutzer)",
      "seats_per_class" : "Plätze pro Kurs",
      "pre_buffer_time" : "Vorlaufzeit",
      "post_buffer_time" : "Nachlaufzeit",
      "pre_buffer_tooltip" : "Vorlaufzeit ist zusätzliche Zeit, die vor einem Termin hinzugefügt werden kann, um zusätzliche Zeit zum Vorbereiten zu haben",
      "post_buffer_tooltip" : "Nachlaufzeit ist zusätzliche Zeit, die nach einem Termin hinzugefügt werden kann, um zusätzliche Zeit zum Nachbereiten zu haben",
      "buffer_time" : "Pufferzeit",
      "daily" : "Täglich",
      "weekly" : "Wöchentlich",
      "monthly" : "Monatlich",
      "skip_booking" : "Buchung von nicht verfügbaren Zeitfenstern überspringen",
      "continue_booking" : "Buchung fortsetzen",
      "book_next_available" : "Nächstes verfügbares Zeitfenster buchen",
      "confirmed" : "Bestätigt",
      "unconfirmed" : "Unbestätigt",
      "enter_valid_hours" : "Bitte gib gültige Öffnungszeiten ein",
      "enter_valid_avail" : "Bitte gib eine gültige kundenspezifische Verfügbarkeit ein",
      "availability_type_tooltip" : "Wähle „Standardverfügbarkeit“ für wöchentlich angebotene reguläre Buchungen. Wähle „Benutzerdefiniert“ für Buchungen, die nur an bestimmten Terminen verfügbar sind.",
      "meeting_interval_tooltip" : "Das Besprechungsintervall gibt die Zeitspanne zwischen den Buchungszeiträumen an, die im Kalender angezeigt werden. Bei einer 30-minütigen Veranstaltung, die zu jeder vollen Stunde verfügbar sein soll, beträgt das Intervall 1 Stunde. Bei einer 30-minütigen Veranstaltung, die alle 30 Minuten verfügbar sein soll, beträgt das Intervall 30 Minuten.",
      "date_range_tooltip" : "Veranstaltungen können in den nächsten n Tagen geplant werden.",
      "maximum_bookings_per_day_tooltip" : "Max.. Nummer von Besprechungen, die je Tag An diesem Kalender zulässig sind",
      "maximum_bookings_per_slot_tooltip" : "Maximale Anzahl an Terminen, die pro Zeitfenster für den Benutzer zulässig sind. (Wenn die Anzahl der Termine für das angegebene Zeitfenster des Benutzers überschritten wird, wird entweder zum nächsten Benutzer in der Round-Robin-Warteschlange gewechselt oder das Zeitfenster wird als für die Buchung durch den Interessenten nicht verfügbar markiert.)",
      "add_days" : "Tage hinzufügen",
      "month_on_day" : "Monatlich am Tag",
      "month_on_last_day" : "Monatlich am letzten Tag",
      "day" : "Tag",
      "week" : "Woche",
      "month" : "Monat",
      "mins" : "Minuten",
      "hours" : "Stunden",
      "days" : "Tage",
      "weeks" : "Wochen",
      "months" : "Monate",
      "meeting_interval_error" : "Das Besprechungs-Intervall muss zwischen 5 Minuten und 12 Stunden liegen",
      "meeting_duration_error" : "Die Dauer des Meetings muss zwischen 1 Minute und 12 Stunden liegen",
      "buffer_time_error" : "Die Pufferzeit muss weniger als 12 Stunden betragen",
      "appointment_interval" : "Terminintervall",
      "appointment_duration" : "Dauer des Termins",
      "maximum_appointments_per_day" : "Maximale Anzahl an Terminen pro Tag",
      "subTitle" : "Wähle das Datum, um bestimmte Stunden festzulegen",
      "heading_1" : "Wöchentlich verfügbare Stunden",
      "scheduling_availability_heading" : "Buchungsverfügbarkeit",
      "tooltip_1" : "Lege deinen wöchentlichen Verfügbarkeitsplan fest. Dies sind deine Standardstunden, die wöchentlich einheitlich angewendet werden",
      "heading_2" : "Wann bist du verfügbar?",
      "unavailable_label" : "Nicht verfügbar",
      "tooltip_2" : "Passe deinen Zeitplan für bestimmte Termine an. Überschreibe deine regulären Wochenstunden, indem du die Verfügbarkeit oder Nichtverfügbarkeit für ausgewählte Daten markierst.",
      "date_specific_level" : "Datumsspezifische Stunden hinzufügen",
      "specific_hours_button" : "Datumsspezifische Uhrzeiten",
      "specific_hours_description" : "Überschreibe deine Verfügbarkeit für bestimmte Daten, wenn deine Stunden von deinen regulären Wochenstunden abweichen.",
      "overlap_error" : "Zeitfenster dürfen sich nicht überschneiden",
      "apply" : "Anwenden",
      "copy_times_to" : "Zeiten kopieren nach",
      "no_date_specific_heading" : "Keine datumsspezifische Uhrzeit hinzugefügt",
      "no_date_specific_description" : "Du kannst bestimmte Daten und Uhrzeiten zu deiner Verfügbarkeit hinzufügen/entfernen",
      "recurring_disabled_conditions_tooltip" : "Wiederkehrend-Besprechungen werden deaktiviert. Um sie auslöser, stelle sicher, dass der Kalender nur eine Gruppe Mitglieder enthält und keine datumsspezifische Zahlung von Stunde oder Unvollständig hinzugefügt wurde.",
      "date_specific_hours_disabled_conditions_tooltip" : "Wenn du eine datumsspezifische Uhrzeit angeben möchtest, stelle sicher, dass wiederkehrende Besprechungen deaktiviert sind.",
      "recurring_disable_event_calendar_conditions" : "Wiederkehrend-Besprechungen werden deaktiviert. Um Auslöser zu stellen, stelle sicher, dass keine datumsspezifische Stunde oder Unvollständig Zahlung hinzugefügt wurde.",
      "service_duration" : "Servicedauer",
      "service_interval" : "Serviceintervall",
      "service_interval_tooltip" : "Das Besprechungsintervall legt fest, wie oft Buchungszeiträume im Kalender erscheinen. Bei einer 30-minütigen Veranstaltung bedeutet ein 1-Stunden-Intervall beispielsweise, dass stündlich Zeitfenster angezeigt werden. Ein 30-Minuten-Intervall bedeutet, dass alle 30 Minuten Zeitfenster erscheinen.",
      "service_duration_tooltip" : "Dies legt die Dauer deines Termins fest und bestimmt, wie lange er dauern wird.",
      "minimum_scheduling_tooltip" : "Hiermit legst du die Mindestzeit fest, die zum Buchen eines Termins über das Kalender-Widget erforderlich ist. Wenn beispielsweise ein Termin auf 4 Stunden festgelegt ist, können Termine nicht innerhalb von 4 Stunden vor ihrer Startzeit gebucht werden; Buchungen müssen mindestens 4 Stunden im Voraus erfolgen.",
      "look_busy_title" : "Als nicht verfügbar anzeigen",
      "look_busy_helper_text" : "Ausblenden einen Prozentsatz von deinen verfügbaren Termin-Zeitfenstern und dem Booking Widget, um geschäftiger und in zu erscheinen",
      "look_busy_percentage_description" : "Die Anzahl der verfügbaren Zeitfenster um x % ausblenden",
      "maximum_bookings_per_slot_tooltip_personal" : "Beschränkung, wie vielen Besprechungen für das gleiche Zeitfenster Geplant werden können",
      "enable_recurring_title" : "Wiederkehrend Konferenzen aktivieren",
      "enable_recurring_desc" : "Durch das Einschalten von <b>Wiederkehrend-Besprechungen</b> werden die Nachlauf-Einstellungen automatisch deaktiviert, da sie nicht Koexistieren können:",
      "date_specific_hours" : "jeder <b>datumsspezifische Stunden</b> werden gelöscht.",
      "multiple_team_members" : "<b>Mehrere Gruppe-mitglieder</b> werden abmeldung – nur ein Gruppe-mitglieder kann in diesem Kalender bleiben.",
      "partial_payments" : "<b>Unvollständig Zahlungen</b> werden deaktiviert und der Voll-Betrag wird einziehen.",
      "select_team_member_to_keep" : "Auswählen einer Gruppe Mitglieder zum Behalten in diesem Kalender:",
      "select_team_member" : "Auswählen Gruppe Mitglieder",
      "partial_payments_disabled" : "Unvollständig Zahlungen werden deaktiviert, wie Like Sie den Voll-Betrag für die Wiederkehrend-Termin einziehen?",
      "enable_date_specific_hours" : "Datum Stunden Aktivieren",
      "enable_date_specific_hours_desc" : "Durch das Umstellen <b>datumsspezifischer Stunden</b> wird die Nachlauf-Einstellung automatisch deaktiviert, da sie nicht nebeneinbeziehen werden:",
      "recurring_meetings_disabled" : "<b>Wiederkehrende Besprechungen werden deaktiviert</b>, {contactsLabel} kann nur einzelne Termine basierend auf den von Ihnen festgelegten verfügbaren Daten buchen.",
      "payment_preference" : "Bezahlung :",
      "team_members_in_this_calendar" : "Gruppe Mitglieder in diesem Kalender",
      "other_team_members" : "Andere Gruppe Mitglieder (Nicht zu diesem Kalender hinzugefügt)",
      "select_team_member_tooltip" : "Auswählen der Gruppe Mitglieder, die diese Konferenzen annehmen möchten",
      "meeting_duration_tooltip" : "Dies legt die Länge deiner Konferenzen fest und bestimmt, wie lange sie dauern wird",
      "date_specific_hours_tooltip" : "Ändern Sie Ihren Zeitplan für bestimmte Termine. Überschreibe deine Monatlich Wöchentlich Stunde Via Kennzeichnung Verfügbarkeit oder Nichtverfügbarkeit für ausgewählte Termine",
      "recurring_meeting_tooltip" : "Aktivieren Sie Besprechungen, um mehrere Mal über eine Woche wiederzuholen",
      "repeat_frequency_tooltip" : "Auswählen der Frequenz von diesem wiederkehrenden Veranstaltung",
      "time_to_repeat_tooltip" : "Sammlung der Gesamtnummer von Wiederholungen",
      "slots_unavailable_tooltip" : "Auswählen, was stattfinden soll. Fällt ein oder mehrere Datums-Zeitfenster in einer Wiederkehrend-Buchung aus, die bereits gebucht ist",
      "skip_booking_tooltip" : "Es werden nur die verfügbaren Zeitfenster gebucht. Alle nicht verfügbaren Termine in der Wiederkehrend-Reihe werden überspringen",
      "force_book" : "Buch ersetzen",
      "force_booking_tooltip" : "Jeder Zeitfenster wird gebucht, Gleich Falls da ist ein Konflikt. Mit Vorsicht verwenden, um Doppelbuchungen zu vermeiden",
      "book_next_available_tooltip" : "Wenn ein ausgewähltes Zeitfenster nicht verfügbar ist, Buch das nächste verfügbare Zeitfenster An den gleichen Wiederkehrend-Plan (z. B., Nächste Montag Falls Wöchentlich)",
      "slot_interval_tooltip" : "Sammlung der Pause zwischen den Start-Zeitfenstern von aufsteigenden verfügbaren Zeitfenstern. Für Model, Falls Ihre Konferenzen Dauer 30 Minuten und Sie Sammlung die Sekunden auf 60 Minuten beträgt, kann ein Benutzer um 9:00 AM, Then 10:00 AM und so Buchen – Gleich, ob alle Konferenzen nur 30 Minuten dauern",
      "minimum_scheduling_notice_tooltip" : "Erforderlich Benutzer, um Besprechungen mindestens so viel Datum in Voraus zu buchen",
      "date_range_preferences_tooltip" : "Sammlung, wie bis in die Zukunft Buchungen von Heute's Datum vorgenommen werden können",
      "maximum_bookings_per_slot_preferences_tooltip" : "Beschränkung, wie vielen Besprechungen für das gleiche Zeitfenster Geplant werden können",
      "maximum_bookings_per_slot_per_user_preferences_tooltip" : "Beschränkung, wie vielen Besprechungen für dasselbe Zeitfenster (je Benutzer) geplant werden können",
      "pre_buffer_time_tooltip" : "Datum zum Blockieren Vorher jeder Konferenzen, Aktivieren für zusätzliches Datum zur Vorbereitung",
      "post_buffer_time_tooltip" : "Datum zum Blockieren später jeder Konferenzen, Aktivieren für zusätzliches Datum zum Nachbereiten",
      "seats_per_class_tooltip" : "Sammlung des Max.. Nummer von Benutzern, die diese Klasse buchen dürfen. Sobald jeder Plätze gefüllt ist, ist das Zeitfenster nicht mehr für Buchungen verfügbar",
      "maximum_bookings_per_slot_per_user_tooltip" : "Beschränkung, wie vielen Besprechungen für dasselbe Zeitfenster (je Benutzer) geplant werden können",
      "repeat_frequency" : "Wiederholen die Frequenz",
      "slot_interval" : "Zeitfenster Sekunden",
      "skip_booking_helper_text" : "Es werden nur die verfügbaren Zeitfenster gebucht. Alle nicht verfügbaren Termine in der Wiederkehrend-Reihe werden überspringen",
      "force_book_helper_text" : "Jeder Zeitfenster wird gebucht, Gleich Falls da ist ein Konflikt. Mit Vorsicht verwenden, um Doppelbuchungen zu vermeiden",
      "book_next_available_helper_text" : "Wenn ein ausgewähltes Zeitfenster nicht verfügbar ist, buchen Sie das nächste verfügbare Zeitfenster und den gleichen Wiederkehrend-Plan (z. B. Nächste Montag Falls Wöchentlich).",
      "bulk_edit" : "Massedaten bearbeiten",
      "select_users" : "Benutzer auswählen",
      "select_all" : "Alle auswählen",
      "times_to_repeat_tooltip" : "Gesamtanzahl der Wiederholungen festlegen"
    },
    "forms_payment" : {
      "forms" : "Formulare",
      "forms_sub" : "Lege die Formulareinstellungen für die Nachbereitung fest.",
      "select_form" : "Formular auswählen",
      "enable_same_user_assignment" : "Weise bei jeder Terminbuchung Kontakte ihren jeweiligen Kalenderteammitgliedern zu",
      "sticky_contacts" : "Felder vorab ausfüllen (Sticky Contacts)",
      "confirmation_page" : "Bestätigungsseite",
      "default" : "Standard",
      "redirect_url" : "Weiterleitungs-URL",
      "thank_you" : "Dankesnachricht",
      "enter_url" : "URL eingeben",
      "amount_tab_hidden_label" : "Platzhalter den Betrag",
      "percentage_tab_hidden_label" : "Platzhalter für den Prozentsatz",
      "pixel_id" : "Meta Pixel-Id (Optional)",
      "auto_confirm" : "Neue Kalenderbesprechungen automatisch bestätigen",
      "configure_payment" : "Zahlungsoptionen konfigurieren",
      "accept_payments" : "Zahlungen akzeptieren",
      "test" : "Test",
      "live" : "Live",
      "enable_guests" : "Gäste hinzufügen",
      "add_guest_tooltip" : "„Gast hinzufügen“ ermöglicht es deinem Teilnehmer, mehrere Teilnehmer zum selben Termin hinzuzufügen",
      "add_guest_custom_form_tooltip" : "Bei Aktivierung dieser Option wird eine vom System generierte E-Mail mit einem Link zum benutzerdefinierten Formular an die Gäste gesendet, sobald ihr Termin bestätigt wurde. Um doppelte E-Mail-Versand zu vermeiden, stell bitte sicher, dass nicht bereits eine separate Bestätigungs-E-Mail für Gäste eingerichtet ist. (Überprüfen kannst du dies auf der Registerkarte „Benachrichtigungen“ > „Bestätigungsbenachrichtigung“.)",
      "add_guest_same_form_check" : "Sende dasselbe Formular zur Informationserfassung per E-Mail an alle Gäste",
      "payment_tooltip" : "Die Zahlung wird nur für den Hauptteilnehmer und nicht für die Gäste berücksichtigt.",
      "default_form" : "Standard (Vorname, Nachname, E-Mail, Telefon, Notizen)",
      "select_form_tooltip" : "Wenn du von den Personen, die diesen Kalender buchen, mehr Informationen als nur Vorname, Nachname, E-Mail-Adresse und Telefonnummer erfassen möchtest, erstelle ein benutzerdefiniertes Formular unter „Sites > Formulare > Builder“ und wähle das Formular dann über die Dropdown-Liste unten aus.",
      "confirmation_page_tooltip" : "Sobald jemand eine Buchung getätigt hat, kannst du wählen, ob du ihm eine benutzerdefinierte Nachricht auf derselben Seite anzeigen möchtest (Standard) oder ihn auf eine Seite deiner Wahl umleiten möchtest (Weiterleitung).",
      "add_guest_collect_email" : "Name und E-Mail",
      "add_guest_count_only" : "Nur Anzahl",
      "custom_email_notification" : "Benutzerdefiniertes Formular an Gäste senden",
      "consent_label" : "Kontrollkästchen „Einwilligung“",
      "consent_input_placeholder" : "Einwilligungstext hinzufügen",
      "same_user_assignment_tooltip" : "Um diese Einstellung zu aktivieren, muss sich das Formular an erster Stelle im Widget befinden. Ordne das Widget neu an, um das Formular zuerst zu positionieren, um diese Einstellung zu aktivieren.",
      "consent_tooltip" : "Aktiviere diese Option, um die Genehmigung von {contactsLabel} einzuholen, wenn sie ihre Rufnummer während des Terminbuchungsprozesses angeben.",
      "stripe_error" : "Bis zu zwei Dezimalstellen (Beispiel: 25,99)",
      "auto_confirm_service" : "Neue Termine automatisch bestätigen",
      "service_form_message" : "Wenn ein Kontakt mehrere Services bucht, wird er nur das Standardformular im Servicemenü sehen",
      "deposit_amount_error" : "Der Einzahlungsbetrag muss geringer sein als der Gesamtbetrag.",
      "deposit_percentage_error" : "Der Einzahlungsprozentsatz muss unter 100 % liegen.",
      "partial_payment_tooltip" : "Aktivieren Sie Unvollständig Zahlungen, um den Einzahlungsbetrag von Kunden während der Terminbuchungs- Pipeline einziehen zu können",
      "partial_payment_enable_error" : "Der eingegebene Gesamtbetrag muss größer als 0 sein, um Teilzahlungen zu ermöglichen.",
      "payment_disable_text_integration" : "Integriere einen Zahlungsanbieter unter Zahlungen > Integrationen, um Zahlungen zu akzeptieren",
      "payment_disable_text_recurring" : "Die Option „Zahlung akzeptieren“ ist für wiederkehrende Besprechungen nicht verfügbar. Schalte wiederkehrend aus, um Zahlungen zu aktivieren.",
      "date_and_time_selector" : "Datums- und Uhrzeitauswahl",
      "form_selector" : "Formular",
      "order_step" : "Schritt",
      "widget_order_label" : "Widget-Reihenfolge",
      "widget_order_tool_tip" : "Ordne die Reihenfolge „Datums- und Uhrzeitauswahl“ und „Formular“ im Kalender-Widget neu an. Ordne sie per Drag & Drop nach deiner Präferenz neu an.",
      "widget_re_order_tooltip" : "Die Neuanordnung ist nur mit dem Neo-Widget-Stil verfügbar. Wechsle zu Neo, um die Neuanordnung zu aktivieren.",
      "widget_re_order_disabled_tooltip" : "Um die Widget-Reihenfolge zu ändern, deaktiviere die Option „Neue Termin-Einstellung (immer mit dem zugewiesenen Benutzer von {contactLabel} buchen)“ im Abschnitt Besprechungsdetails > Teammitglieder > Erweiterte Einstellungen.",
      "payment_description_error" : "Maximale Zeichenanzahl von 1000 erreicht",
      "widget_multiple_location_disabled_tooltip" : "Das Widget Klassisch unterstützt nicht mehrere Besprechungsorte. Bitte entferne alle zusätzlichen Standorte, um das Klassisch-Widget zu verwenden",
      "recurring_payment_label" : "Zahlung für wiederkehrende Termine",
      "enable_payments_for_guests" : "Zahlungen für Gäste Aktivieren",
      "guest_payment_description" : "Da du die Option „Gäste hinzufügen“ aktiviert hast, kannst du bei der Buchung auch Gebühr je Gast auswählen.",
      "charge_per_attendee" : "Bitte geben Sie den Gast ein",
      "charge_per_attendee_description" : "Multipliziere den Gesamtbetrag mit der Nummer von Teilnehmern (einschließlich Gäste), wenn du bei der Buchung die Zahlung einziehen möchtest.",
      "click_confirm_description" : "Klicken Sie auf „Speichern“, um diese Änderungen zu speichern.",
      "multiply_amount_guests" : "Zahlung für alle Teilnehmer einziehen",
      "multiply_amount_guests_description" : "Wenn aktiviert, wird der bei der Buchung einziehende Betrag mit der Gesamtnummer von Teilnehmern, einschließlich der Gäste, multipliziert",
      "first_appointment_only" : "Gebühr nur für den ersten Termin",
      "all_appointments" : "Gebühr für jeden Termin im Voraus",
      "no_payment_provider_connected" : "Kein Provider verbunden",
      "no_default_payment_provider" : "Kein Provider verbunden",
      "provider_not_supported" : "Der Standard Provider wird nicht unterstützt",
      "manage_payment_provider" : "Bezahlung Verwalten",
      "supported_providers" : "Unterstützte Drittanbieter",
      "paypal_razorpay_helper_text" : "Payments will be processed through Razorpay only, as PayPal isn’t supported with custom providers",
      "rearrange_widget_order" : "Verschieben Widget Sortieren",
      "change_form_order" : "Dynamisch das Formular zum ersten Schritt in Widget Sortieren wird die Nachlauf-Einstellungen deaktivieren:",
      "change_form_order_desc" : "<b>Neue Terminpräferenz (immer mit dem zugewiesenen Benutzer des {contactLabel} buchen)</b> wird deaktiviert. Das bedeutet, dass Termine mit jedem verfügbaren Gruppenmitglied gebucht werden können, anstatt auf den dem {contactLabel} zugewiesenen Benutzer beschränkt zu sein.",
      "enable_mandatory_guest" : "Erstellen Sie mindestens einen Gast erforderlich. Gast Felder werden vorgeöffnet und müssen vor ihrer Buchung ausgefüllt werden.",
      "enable_mandatory_guest_count" : "Überprüfe die Erforderlich Gast Anzahl An dem Booking Widget",
      "require_guest_for_booking" : "Erforderlich Gäste bei der Buchung",
      "sticky_contacts_tooltip" : "Felder für bekannte {contactsLabel} automatisch ausfüllen.",
      "auto_confirm_tooltip" : "Neuen Besprechungen automatisch als Bestätigt zuweisen, ohne dass eine Manuell Genehmigung erforderlich ist. Deaktivieren Sie diesen Falls Sie möchten eine Bewertung abgeben und jede Buchung manuell bestätigen, bevor Sie es Geplant sind",
      "confirm_tooltip" : "Sobald jemand eine Buchung getätigt hat, kannst du Auswählen, um ihm eine Benutzerdefinierte Nachricht auf derselben Seite anzuzeigen (Standard) oder ihn auf eine Seite von deiner Wahl umzuleiten (Weiterleitungs-URL)",
      "facebook_pixel_id_tooltip" : "",
      "accept_payments_tooltip" : "Bezahlung bei Sammlung Aktivieren",
      "total_amount_tooltip" : "Sammlung der Gesamtgebühr für die Konferenzen",
      "deposit_amount_tooltip" : "Betrag , der bei der Buchung als Anzahlung einziehen wird",
      "multiply_amount_guests_all_guests" : "Ziehe die Zahlung für alle Teilnehmer, auch Gäste, ein",
      "multiply_amount_guests_all_guests_tooltip" : "Wenn aktiviert, wird der bei der Buchung einziehende Betrag mit der Gesamtnummer von Teilnehmern, einschließlich der Gäste, multipliziert",
      "payment_description" : "Bezahlung",
      "payment_description_tooltip" : "Optional Einbeziehen aller hilfreichen Details Über die Zahlung",
      "test_mode_warning" : "Test-Modus Dynamisch – kein wirklicher Umsatz wird bearbeitet.",
      "pixel_id_tooltip" : "Upload des Booking Widget Aktivität wie Ansichten, Klicks und Einsendungen an Meta über deine PixelId",
      "forms_description" : "Konfigurieren Sie die Felder und fließen Sie aus Ihrem Buchungsformular",
      "payment_mode" : "Bezahlung",
      "payment_mode_tooltip" : "Schalte zwischen Test-Modus und Live Modus für Zahlungen um. in Test-Modus werden keine wirklichen Abrechnungen erstellt – verwenden Sie sie, um die Buchungs- und Zahlungs Pipeline zu testen. Wechsle in den Live Modus, um aktuelle Zahlungen von Kunde zu akzeptieren.",
      "enable_coupon" : "Gutscheincodes aktivieren",
      "enable_coupon_tooltip" : "Ermöglichen Sie Kunden, während der Buchung Gutscheincodes anzuwenden. Um sicherzustellen, dass sie funktionieren, erstellen Sie zuerst gültige Gutscheincodes unter Zahlungen > Gutscheincodes."
    },
    "notifications" : {
      "notifications" : "Benachrichtigungen und zusätzliche Optionen",
      "notifications_sub" : "Benachrichtigungen und zusätzliche Optionen konfigurieren",
      "edit" : "Bearbeiten",
      "created_on" : "Erstellt am",
      "updated_on" : "Aktualisiert am",
      "delivered" : "Zugestellt",
      "not_available" : "K. A.",
      "select_notification_type" : "Wähle die Art der Benachrichtigung",
      "notification_person" : "Wer soll diese Benachrichtigung erhalten?",
      "contact" : "{contactLabel}",
      "guest" : "Gast",
      "assigned_user" : "Zugewiesener Benutzer",
      "emails" : "E-Mails",
      "alert_email_address" : "E-Mail-Adresse für Benachrichtigungen",
      "ack_email" : "Bestätigungs-E-Mail",
      "send_google_invites" : "Erlaube Google Kalender, Einladungs- oder Aktualisierungs-E-Mails an Teilnehmer zu senden.",
      "send_google_outlook_invites" : "Aktivieren Sie Google / Outlook / iCloud Kalender, um Einladungs- & Aktualisierungs-E-Mails an Teilnehmer zu Uploaden.",
      "assign_user_to_contact" : "Weise {contactsLabel} bei jeder Terminbuchung ihren jeweiligen Kalenderteammitgliedern zu",
      "skip_assigning_user_to_contact" : "Überspringe die Zuweisung von {contactLabel}, falls {contactLabel} bereits einem Benutzer zugewiesen ist",
      "assigned_staff" : "Zugewiesene Mitarbeiter",
      "additional_emails" : "Zusätzliche E-Mails",
      "assign_user_to_staff" : "Weise {contactsLabel} bei jeder Terminbuchung den jeweiligen Servicemitarbeitern zu",
      "allow_cancellation" : " Absage der Besprechung zulassen",
      "allow_reschedule" : "Verschiebung der Besprechung zulassen",
      "allow_cancellation_tooltip" : "Wenn diese Option aktiviert ist, wird ein Link zur Absage in den Abschnitt für zusätzliche Notizen und in die Kalendereinladung aufgenommen. Dieser Link läuft wie konfiguriert vor der Startzeit des Meetings ab, sodass der Buchende die Besprechung nicht absagen kann.",
      "allow_reschedule_tooltip" : " Wenn diese Option aktiviert ist, wird ein Link zur Terminverschiebung dem Abschnitt für zusätzliche Notizen hinzugefügt und in die Kalendereinladung aufgenommen. Dieser Link läuft wie konfiguriert vor der Startzeit des Meetings ab und verhindert, dass der Buchende die Besprechung verschiebt.",
      "cancellation_link_expiry" : "Der Link zur Absage läuft ab",
      "reschedule_link_expiry" : "Der Link zur Terminverschiebung läuft ab",
      "before_meeting" : "vor der Besprechung",
      "cancellation_and_reschedule_policy" : "Absage- und Umbuchungsbedingungen:",
      "meeting_invite_notes" : "Konferenzen Einladungsnotizen",
      "meeting_invite_notes_tooltip" : "Notizen hinzufügen, die in der Kalendereinladung angezeigt werden, die an den Kunden gesendet wurde. Diese Notizen werden mit Kalender von Drittanbietern in der Konferenzen Beschreibung synchronisiert"
    },
    "connections" : {
      "connections_heading" : "Externe Kalendersynchronisierung",
      "connections_sub" : "Veranstaltungen mit externem Kalender synchronisieren",
      "link_to_calendar" : "Link zum Kalender",
      "sync_option" : "Option „Synchronisieren“",
      "execute_automation" : "Automatisierung ausführen",
      "fire_workflow" : "Workflow-Trigger für über Zwei-Wege-Synchronisierung gebuchte Veranstaltungen auslösen",
      "reserve_with_google" : "Mit Google buchen (veraltet werden)",
      "reserve_with_google_setup" : "Ansicht Konfig Anweisungen",
      "reserve_with_google_configure" : "Konfiguration",
      "change" : "Ändern",
      "rwg_deprecation_notice" : "Google hat <strong>Buch mit Google (RomG)</strong>, wie <strong>Local Dienste Anzeigen</strong> bezeichnet, abgelehnt. Neue Verbindungen werden nicht mehr unterstützt. Um Buchungen über Google weiter zu erhalten, verwenden Sie bitte stattdessen <strong>Organic Google-Buchung</strong> .",
      "rwg_category" : "Kategorie",
      "rwg_service_type" : "Service",
      "connect_lsa" : "Mit deinem Local Services Ads-Konto verbinden",
      "reserve_error" : "Derzeit wird Reserve bei Google nur für „Home Services“, „Real Estate“, „Legal Services“ (lokale Dienstleister) in den Vereinigten Staaten unterstützt.",
      "one_way" : "Einwege",
      "two_way" : "Zweiwege",
      "smart" : "Intelligent",
      "confirm_remove" : "Möchtest du den Google-Kalender wirklich entfernen?",
      "read_only_access" : "Du hast keinen Schreibzugriff auf diesen Kalender. Bitte wähle einen anderen Kalender aus.",
      "reserve_with_google_desc" : "Dieser Kalenderservice wird erst nach erfolgreicher Integration bei Google als Reserve aufgeführt.",
      "check_integration" : "Überprüfe deinen Integrationsstatus",
      "setup_external" : "Richte deinen externen Kalender ein",
      "reserve_price_decimal_error" : "Dezimalpreis wird nicht unterstützt",
      "reserve_price_max_error" : "Unterstützter Preis unter 1000",
      "link_to_calendar_tooltip" : "Wähle den Kalender aus, mit dem du diesen Kalender synchronisieren möchtest",
      "one_way_sync" : "Ein-Weg",
      "default_one_way" : "Standardsynchronisierung (Ein-Weg-Synchronisierung)",
      "one_way_sync_desc" : "Veranstaltungen aus dem verknüpften Kalender werden als blockierte Slots synchronisiert und es werden keine Kontakte für die Gäste erstellt.",
      "two_way_sync" : "Zwei-Wege-Synchronisierung",
      "two_way_sync_desc" : "Kontakte werden für Gäste erstellt, die in verknüpften Kalenderereignissen gefunden werden, und diese Ereignisse werden in Systemtermine umgewandelt.",
      "smart_sync" : "Intelligente Synchronisierung",
      "smart_sync_desc" : "Veranstaltungen aus dem verknüpften Kalender werden als Termine für bestehende Kontakte synchronisiert. Falls kein Kontakt existiert, werden sie als blockierte Slots synchronisiert, ohne dass ein neuer Kontakt erstellt wird.",
      "sync_option_tooltip" : "Wähle aus, wie Vorkommnisse aus deinem externen Kalender mit diesem Kalender synchronisiert werden. Du kannst hier nur die Verfügbarkeit blockieren oder auch {contactsLabel} und Termine erstellen bzw. verwalten – basierend auf dem von dir ausgewählten Synchronisierungsmodus",
      "one_way_sync_tooltip" : "Blockiert Datumsfenster Via Importieren von geschäftigen Ereignissen Von Ihrem Kalender von Drittanbietern",
      "two_way_sync_tooltip" : "Importiert Besprechungen und erstellt {contactsLabel} Termine im System. Änderungen, die hier vorgenommen werden, werden im externen Kalender widergespiegelt",
      "smart_sync_tooltip" : "Importiert Konferenzen und erstellt Termine nur, falls die Besprechung von einem bekannten {contactLabel}erstellt wurde",
      "default_sync" : "Standard",
      "default_sync_desc" : "Synchronisiert Ereignisse von Ihrem externen Kalender mit diesem Kalender",
      "advanced_sync" : "Erweitert",
      "advanced_sync_desc" : "Synchronisiert Veranstaltungen aus Ihrem externen Kalender mit diesem Kalender und erstellt Kontakte und Termine im System",
      "assign_contact_to" : "Kontakt zuordnen zu",
      "select_calendar" : "Kalender auswählen",
      "sync_preferences" : "Synchronisierungseinstellungen",
      "sync_preferences_desc" : "Wie möchten Sie Ihre verknüpften Kalender-Veranstaltungen synchronisieren?",
      "recommended" : "Empfohlen",
      "execute_automation_desc" : "Automatisierung ausführen, wenn eine Konferenz in diesem Kalender erstellt wird",
      "save" : "Änderungen speichern",
      "cancel" : "Abbrechen"
    },
    "extras" : {
      "extras" : "Anpassungen",
      "extras_sub" : "Lege den Stil des Widgets und andere Einstellungen fest.",
      "calendar_widget_style" : "Kalender-Widget-Stil",
      "neo" : "Neu",
      "classic" : "Klassisch",
      "insert_custom_code" : "Benutzerdefinierten Code einfügen",
      "show_seats_per_slot" : "Plätze pro Zeitfenster anzeigen",
      "allow_reschedule_meeting" : "Verschieben von Besprechungen zulassen",
      "allow_cancelling_meeting" : "Absagen von Besprechungen erlauben",
      "additional_notes" : "Zusätzliche Hinweise",
      "cancellation_and_reschedule" : "Absage und Verschiebung:",
      "allow_staff" : "Mitarbeiterauswahl bei der Buchung zulassen",
      "code_block_tooltip" : "Drittanbieter-Skripte innerhalb des HTML-Blocks können zwar leistungsstarke Funktionen bieten, bringen aber auch Risiken für Datenschutz, Sicherheit, Leistung und Seitenverhalten mit sich. Daher empfehlen wir, den Inhalt dieses Skripts zu überprüfen, bevor du es im Kalender speicherst.",
      "calendar_image" : "Kalender-Titelbild",
      "remove_image" : "Bild entfernen",
      "calendar_image_info" : "Das hochgeladene Bild ist in der Gruppenansicht für die Neo-Vorlage sichtbar und erscheint nicht im individuellen Kalenderlink",
      "get_image_from_unsplash" : "Verbessere dein Bildmaterial mit",
      "unsplash" : "Unsplash",
      "service_additional_preferences" : "Zusätzliche Einstellungen konfigurieren",
      "service_image" : "Titelbild des Service",
      "service_image_description" : "Wähle ein Bild aus, das im Servicemenü für diesen Service angezeigt werden soll",
      "allow_reschedule_appointment" : "Terminverschiebung zulassen",
      "allow_cancelling_appointment" : "Terminabsage zulassen",
      "custom_code_placeholder" : "Bitte gib hier den benutzerdefinierten Code ein",
      "calendar_widget_style_desc" : "Wähle zwischen unserem klassischen oder dem eleganten Neo-Widget",
      "seats_per_slot" : "Plätze pro Zeitfenster",
      "show_staff_selection" : "Mitarbeiterauswahl",
      "seats_per_slot_desc" : " Ermögliche Buchenden, die Anzahl der verfügbaren Plätze für jedes Zeitfenster direkt im Kalender-Widget zu sehen.",
      "show_staff_selection_desc" : "Ermögliche Buchenden, bei der Terminbuchung einen Mitarbeiter direkt aus dem Kalender-Widget auszuwählen. Funktioniert nur mit Neo Widget",
      "widget_re_order_tooltip" : "Der klassische Widget-Stil erlaubt keine Änderungen der Widget-Reihenfolge. Stelle sicher, dass die Datums- und Uhrzeitauswahl an erster Stelle und das Formular an zweiter Stelle steht, bevor du den klassischen Stil auswählst.",
      "show_staff_selection_desc_service" : "Ermögliche Buchenden, bei der Terminbuchung einen Mitarbeiter direkt aus dem Kalender-Widget auszuwählen.",
      "switch_to_classic_widget" : "Wechsle zum Klassisch Widget",
      "switch_to_classic_widget_desc" : "Dynamisch mit dem <b>Klassisch Widget</b> werden die Nachlauf-Einstellungen automatisch deaktiviert, da sie nicht Koexistieren können:",
      "form_first_disabled" : "<b>Das Formular wird in den ersten Schritt</b> in Widget Sortieren verschoben.",
      "appointment_preference_disabled" : "<b>Neue Terminpräferenz (immer mit dem zugewiesenen Benutzer des {contactLabel} buchen)</b> wird deaktiviert. Das bedeutet, dass Termine mit jedem verfügbaren Gruppenmitglied gebucht werden können, anstatt auf den dem {contactLabel} zugewiesenen Benutzer beschränkt zu sein.",
      "multiple_location_disabled" : "<b>Mehrere Konferenzen-Adresse</b> werden gelöscht, und nur der <b>zuerst hinzugefügte Standort</b> wird beibehalten.",
      "insert_custom_code_tooltip" : "Anpassen des Widget -Stylings über Ihren eigenen CSS Code",
      "classic_tooltip_disabled" : "Das klassische Widget wird für Klassen-Buchungskalender nicht unterstützt.",
      "show_staff_selection_disabled_tooltip" : "Die Mitarbeiterauswahl wird nur für das Neo-Widget unterstützt."
    },
    "roomsAndEquipments" : {
      "title" : "Wähle Räume und Geräte",
      "description" : "Wähle aus einer Liste von Räumen und Geräten aus, was zusammen mit diesem Kalender gebucht werden soll",
      "rooms" : "Räume auswählen",
      "equipments" : "Geräte auswählen"
    }
  },
  "activity_log" : {
    "activity_log" : "Aktivitätsprotokoll",
    "date" : "Datum",
    "filter_by" : "Filtern nach",
    "calendar_update" : "Kalenderaktualisierung",
    "start_time_update" : "Aktualisierung der Startzeit",
    "end_time_update" : "Aktualisierung der Endzeit",
    "title_update" : "Aktualisierung des Titels",
    "notes_update" : "Aktualisierung der Notizen",
    "appointment_status_update" : "Aktualisierung des Terminstatus",
    "meeting_location_update" : "Aktualisierung des Besprechungsortes",
    "google_sync_update" : "Aktualisierung der Google Synchronisierung",
    "outlook_sync_update" : "Aktualisierung der Outlook-Synchronisierung",
    "assigned_user_update" : "Aktualisierung des zugewiesenen Benutzers",
    "appointment_status" : "Terminstatus",
    "assigned_user" : "Zugewiesener Benutzer",
    "uploaded_to" : "Hochgeladen nach",
    "cancelled" : "Abgesagt",
    "edited" : "bearbeitet",
    "other_edits" : "Andere Bearbeitungen",
    "view_details" : "Details anzeigen",
    "all" : "Alle"
  },
  "appointment_list" : {
    "group_all" : "ALLE",
    "group_primary" : "PRIMÄRE",
    "group_user" : "BENUTZER",
    "group_team" : "GRUPPEN",
    "group_calendar" : "KALENDER",
    "all_appointments" : "Alle Termine",
    "my_calendar" : "Mein Kalender",
    "status_all" : "Alle",
    "status_confirmed" : "Bestätigt",
    "status_new" : "Neu (Aktion erforderlich)",
    "status_show" : "Erschienen",
    "status_no_show" : "Nichterscheinen",
    "status_cancelled" : "Abgesagt",
    "status_invalid" : "Ungültig",
    "filter_date_added_desc" : "Datum hinzugefügt (absteigend)",
    "filter_start_added_desc" : "Startdatum (absteigend)",
    "filter_start_added_asc" : "Startdatum ab heute aufsteigend",
    "button_new_appointment" : "Neuer Termin",
    "name" : "Name",
    "title" : "Titel",
    "requested_time" : "Angeforderte Zeit",
    "date_added" : "Hinzugefügtes Datum",
    "calendar" : "Kalender",
    "appointment_owner" : "Termin-Owner",
    "notes" : "Notizen",
    "status" : "Status",
    "action_view_detail" : "Details anzeigen",
    "action_view_consent" : "Einwilligung anzeigen",
    "action_view_notes" : "Notizen anzeigen",
    "action_edit" : "Bearbeiten",
    "action_delete" : "Löschen",
    "action_reschedule" : "Verschieben",
    "page_previous" : "Vorherige",
    "page_next" : "Nächste",
    "appointment_notes" : "Terminnotizen",
    "close" : "Schließen",
    "confirm_delete_header" : "Termin löschen",
    "confirm_delete_message" : "Bist du sicher, dass du diesen Termin löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden!",
    "confirm_delete_button" : "Löschen",
    "confirm_update_header" : "Terminstatus aktualisieren",
    "confirm_update_confirmed_message" : "Bist du sicher, dass du diesen Termin als bestätigt markieren möchtest?",
    "confirm_update_invalid_message" : "Bist du sicher, dass du diesen Termin als ungültig markieren möchtest?",
    "confirm_update_showed_message" : "Bist du sicher, dass du diesen Termin als erschienen markieren möchtest?",
    "confirm_update_noshow_message" : "Bist du sicher, dass du diesen Termin als nicht erschienen markieren möchtest?",
    "confirm_update_cancelled_message" : "Bist du sicher, dass du diesen Termin als abgesagt markieren möchtest?",
    "confirm_update_button" : "Aktualisierung",
    "empty_state_title" : "Keine Termine gefunden",
    "empty_state_description" : "Keine Termine gefunden",
    "disable_menu_warning" : "Derzeit hast du nicht die Berechtigung, den Termin zu bearbeiten oder zu löschen, da der zugehörige Kontakt nicht dir zugeordnet ist. Bitte wende dich an deinen Administrator, um weitere Unterstützung zu erhalten.",
    "no_contact_warning" : "Du kannst derzeit nicht auf die Kontaktinformationen zugreifen. Dies kann daran liegen, dass der Kontakt dir nicht zugewiesen ist. Bitte wende dich an deinen Administrator, um Hilfe zu erhalten.",
    "consent_label" : "Einwilligung",
    "ip_address" : "IP",
    "youre_viewing_in" : "Wird derzeit angezeigt in",
    "appointment_delete_msg" : "<b>Bitte beachte:</b> Der hier gelöschte Termin wird nicht aus Calendly gelöscht.",
    "rescheduled" : "Verschoben"
  },
  "add_guest" : {
    "guest_label" : "Gast/Gäste",
    "search_placeholder" : "In Kontakten suchen",
    "add_new" : "Neu hinzufügen",
    "save" : "Speichern",
    "close" : "Schließen",
    "name" : "Name",
    "phone" : "Telefon",
    "email" : "E-Mail",
    "guest_label_count" : "Anzahl Gast/Gäste",
    "guest_count_error" : "Die Anzahl der Gäste sollte zwischen 1 und 100 liegen"
  },
  "languages" : {
    "danish" : "Danish",
    "dutch" : "Dutch",
    "english" : "English",
    "finnish" : "Finnisch",
    "french" : "French",
    "french_canada" : "Französisch (Kanada)",
    "german" : "German",
    "hungarian" : "Hungarian",
    "italian" : "Italian",
    "norwegian" : "Norwegisch",
    "polish" : "Polish",
    "portuguese_brazil" : "Portuguese (Brazil)",
    "portuguese_portugal" : "Portuguese (Portugal)",
    "spanish" : "Spanish",
    "swedish" : "Schwedisch",
    "turkish" : "Türkisch"
  },
  "service_menu_advanced" : {
    "new_service_menu_details_header" : "Details zum Servicemenü",
    "select_groups_header" : "Services auswählen",
    "arrange_groups_header" : "Services anordnen",
    "new_service_menu" : "Neues Servicemenü",
    "service_menu_sub_title" : "Erstelle mit nur wenigen Klicks ein personalisiertes Servicemenü für deine Kunden",
    "quick_tip" : "Du kannst Gruppen zum Servicemenü hinzufügen",
    "service_menu_name" : "Name des Servicemenüs",
    "service_menu_description" : "Beschreibung",
    "service_menu_slug" : "Service-URL",
    "select_groups_calendars" : "Gruppen und Kalender auswählen",
    "select_groups_calendars_desc" : "Services zu deinem Servicemenü hinzufügen",
    "select_all" : "Alle auswählen",
    "arrange_groups" : "Reihenfolge der Services festlegen",
    "arrange_groups_desc" : "Reihenfolge der Services im Servicemenü festlegen",
    "arrange_services_quicktip" : "Um Kalender innerhalb einer Gruppe neu anzuordnen, gehe zu Gruppen > Optionen > Kalender neu anordnen.",
    "enable_add_guest_desc" : "Ermöglicht es Kunden, bei der Buchung zusätzliche Gäste hinzuzufügen.",
    "enable_multiple_service_desc" : "Ermöglicht es Kunden, mehrere Services in einem einzigen Termin zu buchen.",
    "enable_staff_selection_desc" : "Ermöglicht es Kunden, bei der Buchung bevorzugte Mitarbeiter auszuwählen.",
    "enable_add_guest" : "„Gäste hinzufügen“ aktivieren",
    "enable_multiple_service" : "Mehrfachauswahl von Services aktivieren",
    "enable_staff_selection" : "Mitarbeiterauswahl aktivieren",
    "additional_options" : "Zusätzliche Optionen",
    "code_block_tooltip" : "Drittanbieter-Skripte innerhalb des HTML-Blocks können zwar leistungsstarke Funktionen bieten, bringen aber auch Risiken für Datenschutz, Sicherheit, Leistung und Seitenverhalten mit sich. Daher empfehlen wir, den Inhalt dieses Skripts zu überprüfen, bevor du es im Kalender speicherst.",
    "custom_code_placeholder" : "Bitte gib hier den benutzerdefinierten Code ein",
    "insert_custom_code" : "Benutzerdefinierten Code einfügen",
    "no_service" : "Keinen Service gefunden",
    "no_service_desc" : " Keine Services gefunden. Erstelle Services und füge sie zu Gruppen hinzu, um ein Servicemenü zu erstellen.",
    "learn_more" : "Mehr erfahren",
    "no_service_selected" : "Kein Service ausgewählt",
    "create_service_calendars" : "Servicekalender erstellen",
    "alert_description" : " Um ein Servicemenü zu erstellen, musst du Service-Kalender erstellen und diese zu Gruppen hinzufügen",
    "dont_show_again" : "Diese Nachricht nicht mehr anzeigen",
    "service_name_required" : "Der Name des Servicemenüs ist erforderlich",
    "slug_already_taken" : "Dieser URL-Teil ist bereits vergeben",
    "slug_required" : "URL-Teil ist erforderlich",
    "please_enter_name" : "Bitte gib einen Namen ein",
    "service_name_placeholder" : "Hauptmenü",
    "service_slug_placeholder" : "Hauptmenü",
    "form_label" : "Formular",
    "consent_label" : "Kontrollkästchen „Einwilligung“",
    "consent_input_placeholder" : "Einwilligungstext hinzufügen",
    "consent_tooltip" : "Aktiviere diese Option, um die Genehmigung von {contactsLabel} einzuholen, wenn sie ihre Rufnummer während des Terminbuchungsprozesses angeben.",
    "back_message" : "Zurück zur Liste",
    "saving_changes" : "Nur eine Minute – Speichern Sie das neueste Dynamisch...",
    "payment_provider_warning" : "Achtung! Service-Menüs unterstützen zur Zeit nur Zahlungen über Stripe und Authorize.net. Da Ihr Standardanbieter abweicht, wird die Zahlungserfassung für ausgewählte Kalender, in denen Zahlungen aktiviert sind, übersprungen.",
    "aria" : {
      "consent_form_toggle" : "Umschaltung der Einwilligungserklärung",
      "enable_add_guest_toggle" : "Umschaltung „Gast hinzufügen“ aktivieren",
      "enable_multiple_services_toggle" : "Umschaltung für mehrere Dienste aktivieren",
      "enable_staff_selection_toggle" : "Umschaltung für die Mitarbeiterauswahl aktivieren"
    }
  },
  "widget_configuration" : {
    "customise_calendar_widget" : "Kalender-Widget anpassen",
    "works_with_neo_widget" : "Funktioniert nur mit Neo Widget",
    "customise_widget_desc" : "Passe das Aussehen des Widgets an: Grundfarbe, Hintergrundfarbe und Schaltflächentext.",
    "learn_more" : "Mehr erfahren",
    "primary_settings" : "Primäre Einstellungen",
    "primary_settings_desc" : "Konfiguriere die Primärfarbe, Hintergrundfarbe und andere Widget-Einstellungen, um dein Kalender-Widget anzupassen",
    "primary_color" : "Primärfarbe",
    "primary_color_desc" : "Definiere die Farbe für Schaltflächen, Daten, Zeitfenster und Aktionen",
    "background_color" : "Hintergrundfarbe",
    "background_color_desc" : "Lege die Hintergrundfarbe fest, die als Hintergrund für die Datums-/Uhrzeitauswahl und das Formular dient.",
    "button_text" : "Schaltflächentext",
    "button_text_desc" : "Passe den Text an, der bei der Terminbuchung auf der Schaltfläche angezeigt wird",
    "calendar_title" : "Kalendertitel",
    "calendar_title_desc" : "Der Name deines Kalenders",
    "calendar_description" : "Kalenderbeschreibung",
    "calendar_description_desc" : "Die eingegebene Beschreibung",
    "calendar_details" : "Kalenderdetails",
    "calendar_details_desc" : "Enthält Informationen wie Dauer, Datum und Uhrzeit, wiederkehrende Details und Zeitzone",
    "reset_to_default" : "Auf Standard zurücksetzen",
    "preview_widget" : "Vorschau-Widget",
    "calendar_title_tooltip" : "Sammlung Falls der Name und der Name (Falls anwendbar) sollten im Booking Widget sichtbar sein.",
    "calendar_description_tooltip" : "Sammlung Fällt in den Kalender Die Beschreibung sollte am Booking Widget sichtbar sein.",
    "calendar_details_tooltip" : "Sammlung Falls die Schlüssel- Besprechungen Details wie Konferenzen Dauer, Ausgewähltes Datum & Datum und Wiederholungsinformationen (Falls anwendbar) sollten am Booking Widget sichtbar sein.",
    "insert_custom_code_tooltip" : "Anpassen des Widget -Stylings über Ihren eigenen CSS Code.",
    "staff_selection_tooltip" : "Aktiviere Booker , um einen Mitarbeiter Mitglieder direkt aus dem Kalender Widget bei der Terminbuchung auszuwählen. Funktioniert nur mit Neo Widget."
  },
  "eventNotification" : {
    "customFields" : "Benutzerdefiniert Felder",
    "customValues" : "Benutzerdefinierte Werte",
    "guest" : "Gast",
    "assignedUser" : "Zugewiesener Benutzer",
    "additionalEmails" : "Zusätzliche E-Mails",
    "list" : {
      "booked" : {
        "title" : "Termin Gebucht (Status: nicht bestätigt)",
        "note" : "Diese Benachrichtigung wird gesendet, wenn ein neuer Termin mit nicht bestätigtem Status erstellt wird.",
        "subTitle" : "Benachrichtigt, wenn ein Termin mit unbestätigtem Status gebucht wird"
      },
      "confirmation" : {
        "title" : "Termin Gebucht (Status: Bestätigt)",
        "note" : "Diese Benachrichtigung wird gesendet, wenn ein Termin mit oder aktualisiert zum Bestätigt Status erstellt wird.",
        "subTitle" : "Benachrichtigt, wenn ein Termin erfolgreich bestätigt wird"
      },
      "cancellation" : {
        "title" : "Absage",
        "note" : "Diese Benachrichtigung wird gesendet, wenn ein Termin abgesagt, als Nichterscheinen, oder als Ungültig markiert wird.",
        "subTitle" : "Benachrichtigungen, wenn ein Termin abgesagt wird"
      },
      "reschedule" : {
        "title" : "Verschieben",
        "note" : "Diese Benachrichtigung wird gesendet, wenn ein Termin verschoben wird. Sie wird nur ausgelöst, wenn sich der Termin in Status„Nicht bestätigt“ oder „Bestätigt“ befindet.",
        "subTitle" : "Benachrichtigt, wenn ein Termin neu geplant wird"
      },
      "reminder" : {
        "title" : "Erinnerung",
        "note" : "Diese Benachrichtigung wird als Erinnerung vor dem Termin gesendet. Sie wird nur ausgelöst, wenn sich der Termin in Status„Nicht bestätigt“ oder „Bestätigt“ befindet.",
        "subTitle" : "Sendet dir eine Erinnerung vor dem Termin"
      },
      "followup" : {
        "title" : "Follow-up",
        "note" : "Diese Benachrichtigung wird später dem Termin als Follow-up gesendet. Sie wird nur ausgelöst, wenn sich der Termin in Status„Nicht bestätigt“, „Bestätigt“ oder „Erschienen“ befindet.",
        "subTitle" : "Sendet nach Abschluss des Termins eine Nachverfolgungsnachricht"
      }
    },
    "saveToastMsg" : "Einstellungen gespeichert!",
    "saveToastMsgDesc" : "Deine Änderungen wurden erfolgreich gespeichert",
    "enableSuccess" : "Benachrichtigungen aktiviert!",
    "disableSuccess" : "Benachrichtigungen deaktiviert!",
    "tooltip" : "Diese Benachrichtigung wurde deaktiviert. Bitte aktivieren Sie es, um ein Dynamisch zu erstellen.",
    "enabled" : "Aktiviert",
    "disabled" : "Deaktiviert",
    "statusLabel" : "Status",
    "email" : {
      "channelName" : "E-Mail",
      "noneTemplate" : "Keine",
      "notificationLabel" : "Wer soll diese Benachrichtigung erhalten?",
      "sendButtonLabel" : "Test-E-Mail senden",
      "testEmailLabel" : "Test-E-Mail",
      "testEmailPlaceholder" : "Gib die E-Mail-Adresse des Empfängers für den Test ein",
      "body" : "E-Mail-Text",
      "bodyPlaceholder" : "Gib hier deine Nachricht ein",
      "subject" : "Betreff",
      "subjectPlaceholder" : "Gib den Betreff der E-Mail ein",
      "templateLabel" : "E-Mail-Vorlage",
      "templatePlaceholder" : "Wähle eine E-Mail-Vorlage oder beginne neu",
      "fromNamePlaceholder" : "Namen eingeben",
      "fromNameLabel" : "Von Name",
      "fromAddressLabel" : "Von Anschrift",
      "alertEmailAddress" : "E-Mail-IDs eingeben (Getrennt über Kommas)",
      "addMore" : "Mehr hinzufügen",
      "afterAppointmentEnds" : "nach Beendigung des Termins",
      "beforeAppointmentStarts" : "bevor der Termin beginnt",
      "durationLabel" : "Wann möchtest du die Benachrichtigung auslösen?",
      "disableEmailNotification" : "E-Mail-Benachrichtigungen deaktivieren",
      "enableEmailNotification" : "E-Mail-Benachrichtigungen aktivieren",
      "enableSuccess" : "E-Mail-Benachrichtigung aktiviert!",
      "enableSuccessDesc" : "Du wirst nun diese Benachrichtigung erhalten",
      "disableSuccess" : "E-Mail-Benachrichtigung deaktiviert!",
      "disableSuccessDesc" : "Du wirst diese Benachrichtigung nicht mehr erhalten",
      "reset_to_default" : "Auf Standard Zurücksetzen",
      "testEmailSuccessTitle" : "Test E-Mail gesendet!",
      "testEmailSuccessDesc" : "Test E-Mail wurde erfolgreich an {email}gesendet",
      "testEmailErrorTitle" : "Test-E-Mail konnte nicht gesendet werden",
      "testEmailErrorDesc" : "Beim Senden der Test-E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
    },
    "inApp" : {
      "channelName" : "in-app",
      "title" : "Benachrichtigungseinstellungen",
      "enableInAppNotification" : "Aktivieren in-App Benachrichtigung",
      "disableInAppNotification" : "Deaktivieren in-App Benachrichtigung",
      "selectedUser" : {
        "label" : "Senden an",
        "helperText" : "Diese interne Benachrichtigung wird über das Web und die mobilen Apps gesendet",
        "placeholder" : "Benutzer auswählen"
      },
      "enableSuccess" : "In-App-Benachrichtigungen aktiviert!",
      "enableSuccessDesc" : "Du wirst nun diese Benachrichtigung erhalten",
      "disableSuccess" : "In-App-Benachrichtigungen deaktiviert!",
      "disableSuccessDesc" : "Du wirst diese Benachrichtigung nicht mehr erhalten"
    },
    "sms" : {
      "channelName" : "SMS",
      "noneTemplate" : "Keine",
      "notificationLabel" : "Wer soll diese Benachrichtigung erhalten?",
      "sendButtonLabel" : "Test-SMS senden",
      "testSMSLabel" : "Test-SMS (geben Sie die Telefonnummer mit Landesvorwahl ein)",
      "testSMSPlaceholder" : "+12345678901",
      "body" : "SMS-Nachricht",
      "bodyPlaceholder" : "Gib hier deine SMS-Nachricht ein",
      "durationLabel" : "Wann möchtest du die Benachrichtigung auslösen?",
      "disableSMSNotification" : "SMS-Benachrichtigungen deaktivieren",
      "enableSMSNotification" : "SMS-Benachrichtigungen speichern",
      "enableSuccess" : "SMS Push-Benachrichtigung aktiviert!",
      "enableSuccessDesc" : "Du wirst ab jetzt diese Benachrichtigung erhalten",
      "disableSuccess" : "SMS-Benachrichtigung deaktiviert!",
      "disableSuccessDesc" : "Du wirst diese Benachrichtigung nicht mehr erhalten",
      "alertPhoneNumbers" : "Telefonnummern eingeben (mit Ländervorwahlen, via Kommas getrennt)",
      "alertPhoneNumbersPlaceholder" : "+12345678901, +447123456789",
      "addMore" : "Mehr hinzufügen",
      "afterAppointmentEnds" : "nach Ende des Termins",
      "beforeAppointmentStarts" : "bevor der Termin beginnt",
      "templateLabel" : "SMS-Vorlage",
      "templatePlaceholder" : "SMS-Vorlage auswählen...",
      "reset_to_default" : "Auf Standard zurücksetzen",
      "testSmsSuccessTitle" : "Test-SMS gesendet!",
      "testSmsSuccessDesc" : "Test-SMS wurde erfolgreich an {phone}gesendet",
      "testSmsErrorTitle" : "Fehlgeschlagen, Test-SMS Upload",
      "testSmsErrorDesc" : "Beim Senden der Test-SMS ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
    },
    "whatsapp" : {
      "channelName" : "WhatsApp",
      "notificationLabel" : "Wer soll diese Benachrichtigung erhalten?",
      "sendButtonLabel" : "Upload Test WhatsApp Push-Benachrichtigung",
      "testWhatsAppLabel" : "Testen Sie die WhatsApp Push-Benachrichtigung (Rufnummer mit Ländercode eingeben)",
      "testWhatsAppPlaceholder" : "+12345678901",
      "durationLabel" : "Wann möchtest du die Benachrichtigung auslösen?",
      "alertPhoneNumbers" : "Telefonnummern eingeben (mit Ländervorwahlen, via Kommas getrennt)",
      "alertPhoneNumbersPlaceholder" : "+12345678901, +447123456789",
      "addMore" : "Mehr hinzufügen",
      "afterAppointmentEnds" : "nach Ende des Termins",
      "beforeAppointmentStarts" : "bevor der Termin beginnt",
      "templateLabel" : "WhatsApp-Vorlage",
      "templatePlaceholder" : "Wählen Sie eine WhatsApp-Vorlage aus...",
      "noPreview" : "Keine Vorlage ausgewählt",
      "templateRequired" : "Vorlage erforderlich",
      "testWhatsAppSuccessTitle" : "Test WhatsApp Push-Benachrichtigung gesendet!",
      "testWhatsAppSuccessDesc" : "Test WhatsApp Push-Benachrichtigung wurde erfolgreich an {phone}gesendet",
      "testWhatsAppErrorTitle" : "Test WhatsApp Push-Benachrichtigung konnte nicht gesendet werden",
      "testWhatsAppErrorDesc" : "Da wurde ein Fehlgeschlagen beim Wird gesendet der Test WhatsApp Push-Benachrichtigung. Bitte versuchen Sie es erneut.",
      "setupTitle" : "Kontaktieren Sie Ihre Kunden über ihre bevorzugte Nachrichten-App",
      "setupDescription" : "Bleiben Sie näher an Ihren Kunden, indem Sie sofortigen Support bieten, zeitnahe Updates senden und ansprechende Interaktionen schaffen.",
      "connectWhatsApp" : "WhatsApp verbinden",
      "checkingStatus" : "Status des WhatsApp-Kontos wird überprüft...",
      "checkingTemplateStatus" : "Überprüfen des Status der WhatsApp-Vorlage...",
      "statusCheckError" : "Überprüfung des WhatsApp-Kontostatus Fehlgeschlagen",
      "templateStatusCheckError" : "Fehlgeschlagen, den WhatsApp-Vorlagenstatus zu Häkchen",
      "setupTemplateTitle" : "Schließen Sie die Einrichtung Ihrer WhatsApp-Vorlage ab",
      "setupTemplateDescription" : "Sie müssen WhatsApp-Vorlagen Konfiguration, Vorher Sie Benachrichtigungen Upload können. Klicken Sie unten, um den Einrichtungsvorgang abzuschließen.",
      "loadTemplatesError" : "WhatsApp-Vorlagen konnten nicht geladen werden",
      "templatesRefreshed" : "Vorlagen erfolgreich aktualisiert",
      "templatesRefreshError" : "Aktualisierung der Vorlagen fehlgeschlagen",
      "templatesResolveError" : "Fehlgeschlagen beim Auflösen von WhatsApp-Standardvorlagen",
      "locationNotFound" : "Standort-ID nicht gefunden",
      "settingsRedirectError" : "Es kann nicht zu den WhatsApp-Einstellungen weitergeleitet werden.",
      "updateNotificationError" : "Fehlgeschlagen, die WhatsApp Push-Benachrichtigung zu aktualisieren.",
      "notificationsEnabled" : "WhatsApp-Benachrichtigungen aktiviert!",
      "notificationsDisabled" : "WhatsApp-Benachrichtigungen deaktiviert!",
      "updateError" : "Fehler beim Aktualisieren der Benachrichtigungen",
      "createNewTemplate" : "Neue WhatsApp-Vorlage erstellen",
      "phoneValidation" : {
        "countryCodeRequired" : "Die Rufnummer muss mit einer Landesvorwahl beginnen (z. B. +1, +91, +44)",
        "digitsOnly" : "Die Rufnummer darf nur Ziffern nach der Landeskennzahl enthalten",
        "tooShort" : "Die Rufnummer ist zu kurz",
        "tooLong" : "Die Rufnummer ist zu lang",
        "invalid" : "Ungültige Telefonnummer"
      },
      "errors" : {
        "templateNotFound" : "Vorlage-ID in den geladenen Optionen nicht gefunden, wird gelöscht.",
        "templateNoLongerValid" : "Gespeicherte Vorlage ist nicht mehr gültig, wird gelöscht",
        "invalidTemplateSelection" : "Es wurde versucht, eine ungültige WhatsApp-Vorlage auszuwählen",
        "fetchingTemplates" : "Fehler beim Abrufen von WhatsApp-Vorlagen",
        "mountingCreator" : "Fehlgeschlagen beim Mounten des WhatsApp-Vorlage-Builders",
        "fetchingAfterCreation" : "Fehlgeschlagen beim Abrufen der WhatsApp-Vorlagen Später der Erstellung",
        "updateStatus" : "Fehler beim Aktualisieren des WhatsApp-Status"
      },
      "receiverLabels" : {
        "assignedUser" : "Zugewiesener Benutzer",
        "phoneNumbers" : "Zusätzliche Telefonnummern"
      }
    }
  },
  "smsTemplate" : {
    "create_new_template" : "Neue SMS-Vorlage erstellen",
    "create_new_template_desc" : "Erstellen Sie eine wiederverwendbare SMS-Vorlage für Ihre Benachrichtigungen",
    "template_name" : "Vorlagenname",
    "template_name_placeholder" : "Vorlagennamen eingeben",
    "message" : "Nachricht",
    "message_placeholder" : "Gib hier deine SMS-Nachricht ein",
    "create_template" : "Vorlage erstellen",
    "name_required" : "Vorlagenname ist erforderlich",
    "text_required" : "Nachrichtentext ist erforderlich",
    "fetch_new_templates" : "Vorlagen aktualisieren"
  },
  "whatsappTemplate" : {
    "create_new_template" : "Neue WhatsApp-Vorlage erstellen",
    "create_new_template_desc" : "Erstellen Sie eine wiederverwendbare WhatsApp-Vorlage für Ihre Benachrichtigungen",
    "template_name" : "Vorlagenname",
    "template_name_placeholder" : "Vorlagennamen eingeben",
    "message" : "Nachricht",
    "message_placeholder" : "Gib hier deine WhatsApp-Nachricht ein",
    "create_template" : "Vorlage erstellen",
    "name_required" : "Vorlagenname ist erforderlich",
    "text_required" : "Nachrichtentext ist erforderlich",
    "fetch_new_templates" : "Vorlagen aktualisieren"
  },
  "archivedServices" : {
    "servicesBanner" : "Eine neue, aktualisierte Version von Diensten ist hier– leistungsstärker, flexibler und interaktiver. Deine Servicekalender wurden bereits verschoben. Entdecken Sie sie jetzt in der Registerkarte „Dienste“.",
    "archivedServiceCalendars" : "Servicekalender (v1)",
    "check_new_services" : "Häkchen Neu Dienste"
  },
  "tour" : {
    "hidden_test_label" : "Test",
    "calendar" : {
      "edit_calendar" : "Kalender Bearbeiten",
      "share_calendar" : "Kalender teilen",
      "troubleshoot_calendar" : "Fehlerbehebung bei Kalendern",
      "more_options" : "Mehr Optionen",
      "edit_calendar_desc" : "Verwalten Sie alle Kalendereinstellungen – Fest Verfügbarkeit, Konfigurationserinnerung, Terminlimits und mehr.",
      "share_calendar_desc" : "Kopieren und teilen Sie Ihren Link zur Terminplanung, damit Booker leicht mit Ihnen planen kann.",
      "troubleshoot_calendar_desc" : "Finden Sie heraus, warum ein Slot nicht angezeigt wird, und sehen Sie sich mögliche Gründe in der Fehlerbehebungsansicht an.",
      "more_options_desc" : "Zugriff auf zusätzliche Einstellungen und Aktivitäten, um deinen Kalender zu verwalten.",
      "read_permissions" : {
        "share_description" : "Gewähren Sie anderen Zugriff, indem Sie den Kalenderlink freigeben oder die Berechtigungen anpassen.",
        "troubleshoot_description" : "Identifizieren und beheben Sie Probleme wie Synchronisierungsfehler oder fehlende Ereignisse für eine reibungslose Funktionalität."
      },
      "next" : "Nächste",
      "start_over" : "Start erneut",
      "all_set" : "jeder Sammlung!",
      "previous" : "Vorherige"
    }
  },
  "emailTemplate" : {
    "select_editing_experience" : "Auswählen Ihre Bearbeiten-Erfahrung",
    "select_editing_experience_desc" : "Auswählen zum Erstellen über unseren sichtbaren Drag-and-Drip-Entwerfen- Editor oder den leistungsstarken Code-Editor",
    "design_editor" : "Entwurfs- Editor",
    "design_editor_desc" : "visuell, Ziehen & Drop-Bearbeitung.",
    "code_editor" : "Code-Editor",
    "code_editor_desc" : "Merkmale-reich HTML -Bearbeitung.",
    "text_editor" : "Einfacher Code-Editor",
    "text_editor_desc" : "Einfach, eindeutig, ohne Schnörper Textkörper-Bearbeitung.",
    "email_text_block" : "E-Mail kann auch über Textkörper- Blockieren erstellt werden. ",
    "select" : "Auswählen",
    "new_template" : "Neue Vorlage",
    "email_block" : "E-Mail kann auch über Textkörper- Blockieren erstellt werden.",
    "fetch_new_templates" : "Neue Vorlagen abrufen"
  },
  "quick_tips" : {
    "meeting_details" : {
      "include_contact_and_user_names" : "Um sowohl den Namen des Kontakts als auch den Namen des Terminbenutzers im Besprechungstitel aufzunehmen, verwenden Sie das folgende Format: &#123;&#123;contact.name&#125;&#125; X &#123;&#123;appointment.user.name&#125;&#125;",
      "add_backup_meeting_url" : "Um einen unterbrechungsfreien Zugriff zu gewährleisten, fügen Sie eine benutzerdefinierte Meeting-URL als Backup-Option hinzu, falls Probleme mit der Zoom- oder Gmeet-Integration auftreten.",
      "enable_gmeet_primary" : "Um die Gmeet-Funktionalität zu aktivieren, stellen Sie sicher, dass der Google Kalender des Teammitglieds in den Einstellungen als primärer Kalender festgelegt ist."
    },
    "availability" : {
      "twenty_four_hours" : "Um den Kalender 24 Stunden verfügbar zu machen, stellen Sie den Zeitraum von 0:00 bis 0:00 Uhr ein.",
      "update_timezone_preferences" : "Zeitzonen können jederzeit unter Unternehmensprofil >> Zeitzoneneinstellungen geändert werden.",
      "service_calendar_slot_interval" : "Legen Sie die Verfügbarkeit Ihres Servicekalenders mit einem Standardintervall von 15 Minuten zwischen den Terminen fest."
    },
    "forms" : {
      "create_custom_forms" : "Erstellen Sie im Abschnitt „Marketing“ unter „Formulare“ ganz einfach benutzerdefinierte Formulare und integrieren Sie diese nahtlos in Kalender für eine organisierte Datenerfassung.",
      "apply_sticky_contacts" : "Wenn Sie ein benutzerdefiniertes Formular hinzufügen, werden die mit dem Formular verknüpften Einstellungen für Sticky Contacts automatisch angewendet.",
      "use_custom_values" : "Sie haben die Möglichkeit, benutzerdefinierte Werte und Kontaktfelder sowohl in die Formularnachricht als auch in die Formular-URL einzufügen."
    },
    "notifications" : {
      "use_workflows" : "Für erweiterte Benachrichtigungen verwenden Sie Arbeitsabläufe oder Auslöser für gebuchte Termine."
    },
    "customizations" : {
      "update_widget_language" : "Um die Spracheinstellungen des Widgets zu ändern, folgen Sie diesen Schritten: Einstellungen >> Kalender >> Einstellungen >> Kontoeinstellungen."
    },
    "equipments" : {
      "room_definition" : "Ein „Raum“ kann jeden Ort darstellen, an dem Dienstleistungen erbracht werden. Dies können physische Räume und/oder dedizierte Stationen sein. Beispiel: Pediküre-Station.",
      "equipment_definition" : "Stellen Sie sich unter „Geräte“ jedes Werkzeug oder Gerät vor, das Unternehmen zur Erfüllung von Terminen verwenden. Dies können Maschinen, Geräte oder auch Stühle sein."
    }
  },
  "aria_labels" : {
    "sticky_contacts" : "Sticky Contacts",
    "consent_form" : "Einwilligungsformular",
    "enable_guests" : "Gäste aktivieren",
    "auto_confirm" : "Automatische Bestätigung",
    "should_accept_payment" : "Sollte Zahlung akzeptieren",
    "collect_deposit" : "Anzahlung einziehen",
    "enable_charge_guests" : "Gebühr für Gäste aktivieren",
    "enable_coupon" : "Coupon aktivieren",
    "payment_live" : "Zahlung Live",
    "add_availability_hour" : "Verfügbarkeit Stunde hinzufügen",
    "remove_availability_hour" : "Verfügbarkeit Stunde entfernen",
    "copy_availability_hour" : "Kopieren Verfügbarkeit Zeit",
    "close_modal" : "Modal schließen",
    "add_custom_slot" : "Benutzerdefiniertes Zeitfenster hinzufügen",
    "remove_custom_slot" : "Benutzerdefiniertes Zeitfenster entfernen",
    "edit_custom_slot" : "Benutzerdefiniertes Zeitfenster bearbeiten",
    "update_frequency" : "Aktualisierungshäufigkeit",
    "show_calendar_title" : "Kalendertitel anzeigen",
    "show_calendar_description" : "Kalenderbeschreibung anzeigen",
    "show_calendar_details" : "Kalenderdetails anzeigen",
    "allow_reschedule" : "Verschiebung zulassen",
    "allow_cancellation" : "Absage zulassen",
    "category_actions" : "Kategorie Aktivitäten"
  },
  "placeholders" : {
    "pixel_id" : "Pixel ID",
    "select_one" : "Eine Option auswählen",
    "meeting_location" : "Besprechungsort",
    "schedule_meeting" : "Konferenz planen",
    "notes" : "Notizen",
    "select_users" : "Benutzer auswählen"
  },
  "alt_text" : {
    "payment_provider" : "Zahlungsanbieter",
    "no_calendars" : "Keine Kalender",
    "date_specific_hours" : "datumsspezifische Stunden",
    "custom_widget_image" : "Benutzerdefiniertes Widget-Bild",
    "service_calendar" : "Servicekalender",
    "event_calendar" : "Veranstaltungskalender",
    "round_robin_booking" : "Round-Robin-Buchung",
    "class_booking" : "Kursbuchung",
    "collective_booking" : "Sammelbuchung"
  },
  "tooltips" : {
    "text_color" : "Textfarbe",
    "background_color" : "Hintergrundfarbe",
    "strikethrough" : "Durchgestrichen",
    "superscript" : "Hochgestellt",
    "subscript" : "Tiefgestellt",
    "inline_code_block" : "Inline-Code-Block",
    "code_block" : "Codeblock",
    "block_quote" : "Blockzitat",
    "more" : "Mehr",
    "upload" : "Upload"
  },
  "labels" : {
    "reset_style" : "Stil zurücksetzen",
    "reset_document_style" : "Dokumentenstil zurücksetzen",
    "source_code" : "Quellcode",
    "success" : "Erfolg",
    "edit" : "Bearbeiten",
    "submit" : "Absenden",
    "cancel" : "Abbrechen",
    "payment" : "Zahlung",
    "here_is_the_link" : "Hier ist der Link:",
    "here_is_the_embed_code" : "Hier ist der Einbettungscode:",
    "service_calendar" : "Servicekalender",
    "collective_booking" : "Sammelbuchung",
    "class_booking" : "Kursbuchung",
    "round_robin_booking" : "Round-Robin-Buchung",
    "event_calendar" : "Veranstaltungskalender",
    "personal_booking" : "Persönliche Buchung",
    "service_booking" : "Servicebuchung"
  },
  "validation_messages" : {
    "calendar_group_name_required" : "Der Name der Kalendergruppe ist erforderlich",
    "calendar_group_description_required" : "Die Beschreibung der Kalendergruppe ist erforderlich",
    "slug_required" : "Slug ist erforderlich",
    "slug_not_valid" : "Dieser Slug ist nicht gültig",
    "slug_already_taken" : "Dieser Slug ist bereits vergeben",
    "error_validating_slug" : "Fehler beim Validieren des Slugs",
    "please_enter_name" : "Bitte geben Sie einen Namen ein",
    "room_name_required" : "Der Raumname ist erforderlich",
    "equipment_name_required" : "Der Gerätename ist erforderlich",
    "subject_required" : "Der Betreff ist erforderlich",
    "this_is_required" : "Das ist erforderlich",
    "calendar_group_slug_required" : "Der Slug der Kalender-Community ist erforderlich",
    "capacity_mandatory" : "Die Kapazität ist erforderlich",
    "capacity_cannot_be_zero" : "Die Kapazität darf nicht null sein",
    "capacity_should_be_a_number" : "Die Kapazität muss eine Zahl sein",
    "capacity_cannot_be_negative" : "Die Kapazität darf nicht negativ sein",
    "capacity_should_be_a_whole_number" : "Die Kapazität muss eine ganze Zahl sein",
    "quantity_mandatory" : "Die Angabe der Anzahl ist erforderlich",
    "quantity_cannot_be_zero" : "Die Anzahl darf nicht null sein",
    "quantity_should_be_a_number" : "Die Anzahl muss eine Zahl sein",
    "quantity_cannot_be_negative" : "Die Anzahl darf nicht negativ sein",
    "quantity_should_be_a_whole_number" : "Die Anzahl muss eine ganze Zahl sein",
    "quantity_cannot_be_less_than_out_of_service_equipments" : "Die Anzahl darf nicht geringer sein als die Anzahl der außer Betrieb befindlichen Geräte.",
    "out_of_service_value_should_be_a_number" : "Der Wert für „außer Betrieb“ muss eine Zahl sein",
    "out_of_service_cannot_be_negative" : "Der Wert für „außer Betrieb“ darf nicht negativ sein",
    "out_of_service_equipments_qty" : "Die Anzahl der außer Betrieb befindlichen Geräte darf die tatsächliche Geräteanzahl nicht überschreiten.",
    "out_of_service_whole_number" : "Der Wert für „außer Betrieb“ muss eine ganze Zahl sein",
    "slot_duration_required" : "Die Zeitfensterdauer ist erforderlich",
    "slot_duration_integer" : "Die Zeitfensterdauer muss eine ganze Zahl sein",
    "meeting_duration_validation" : "Die Dauer der Konferenz muss zwischen einer Minute und 12 Stunden liegen",
    "seats_class_required" : "Die Anzahl der Plätze pro Klasse ist erforderlich",
    "seats_class_integer" : "Die Anzahl der Plätze pro Klasse muss eine ganze Zahl sein",
    "seats_class_validation" : "Diese darf nicht größer als 9999 oder kleiner als 0 sein",
    "meeting_location_required" : "Der Ort der Konferenz ist erforderlich"
  },
  "custom_values" : {
    "assigned_user" : "Zugewiesener Benutzer",
    "full_name" : "Vollständiger Name",
    "first_name" : "Vorname",
    "last_name" : "Nachname",
    "email" : "E-Mail",
    "phone" : "Telefon",
    "twilio_phone" : "Twilio-Telefon",
    "account" : "Konto",
    "name" : "Name",
    "full_address" : "Vollständige Anschrift",
    "city" : "Stadt",
    "state" : "Bundesland",
    "country" : "Land",
    "postal_code" : "Postleitzahl",
    "contact" : "Kontakt",
    "address1" : "Adresse 1",
    "timezone" : "Zeitzone",
    "user" : "Benutzer",
    "appointment" : "Termin",
    "start_date_time" : "Startdatum und Uhrzeit",
    "start_date" : "Startdatum",
    "start_time" : "Startzeit",
    "end_date_time" : "Enddatum und Uhrzeit",
    "end_date" : "Enddatum",
    "end_time" : "Endzeit",
    "meeting_location" : "Besprechungsort"
  },
  "meeting_location_types" : {
    "zoom" : "Zoom",
    "google_meet" : "Google Meet",
    "phone" : "Telefon",
    "full_address" : "Vollständige Anschrift",
    "microsoft_teams" : "Microsoft Teams",
    "custom" : "Benutzerdefiniert"
  },
  "duration_units" : {
    "minutes" : "Minuten",
    "hours" : "Stunden"
  },
  "widget_styles" : {
    "classic" : "Klassisch",
    "neo" : "Neo"
  },
  "feature_labels" : {
    "service_menu" : "Servicemenü",
    "rooms" : "Räume",
    "equipments" : "Geräte"
  },
  "lsa" : {
    "categories" : {
      "accountant" : "Buchhaltung",
      "acupuncturist" : "Akupunktur",
      "air_duct_cleaner" : "Luftkanalreinigung",
      "alcohol_treatment" : "Dienste zur Behandlung von Alkoholismus",
      "animal_shelter" : "Tierrettungsdienste",
      "appliance_repair" : "Gerätereparatur",
      "architect" : "Architektur",
      "assisted_living" : "Dienste für betreutes Wohnen",
      "babysitter" : "Babysitting",
      "bankruptcy_lawyer" : "Insolvenzrecht",
      "beauty_school" : "Kosmetikschule",
      "business_lawyer" : "Unternehmensrecht",
      "car_repair" : "Autoservices",
      "carpenter" : "Zimmerei",
      "carpet_cleaning" : "Teppichreinigung",
      "child_care" : "Kinderbetreuungsdienste",
      "chiropractor" : "Chiropraktische Dienstleistungen",
      "cleaning_service" : "Hausreinigung",
      "contract_lawyer" : "Vertragsrecht",
      "countertop_pro" : "Arbeitsplattenservices",
      "criminal_lawyer" : "Strafrecht",
      "dance_instructor" : "Tanzunterricht",
      "disability_lawyer" : "Behindertenrecht",
      "driving_instructor" : "Fahranweisungen",
      "dui_lawyer" : "DUI-Recht",
      "electrician" : "Elektrisch",
      "energy_efficiency_pro" : "Energieeffizienz-Dienstleistungen",
      "estate_lawyer" : "Erbrecht",
      "event_planner" : "Eventplanung",
      "family_lawyer" : "Familienrecht",
      "fencing_pro" : "Einzäunung",
      "financial_planner" : "Finanzplanung",
      "first_aid_trainer" : "Erste-Hilfe-Kurse",
      "flooring_pro" : "Bodenbelag",
      "foundation_pro" : "Grundlagen",
      "funeral_home" : "Bestattungsdienste",
      "garage_door_pro" : "Garagentor",
      "general_contractor" : "Heimwerkerarbeiten",
      "handyman" : "Handwerker",
      "home_inspector" : "Hausinspektion",
      "home_security" : "Sicherheitsdienste für Privathaushalte",
      "home_theater" : "Heimkino-Dienste",
      "hvac" : "Heizungs-, Lüftungs- und Klimatechnik",
      "immigration_lawyer" : "Einwanderungsgesetz",
      "interior_designer" : "Innenarchitektur",
      "ip_lawyer" : "Geistiges Eigentumsrecht",
      "junk_removal" : "Müllentsorgung",
      "labor_lawyer" : "Arbeitsrecht",
      "landscaper" : "Landschaftsgestaltung",
      "language_instructor" : "Sprachunterricht",
      "lawn_care" : "Rasenpflege",
      "litigation_lawyer" : "Prozessrecht",
      "locksmith" : "Schlüsseldienst",
      "malpractice_lawyer" : "Berufshaftungsrecht",
      "massage_center" : "Massagedienste",
      "massage_school" : "Massageschule",
      "mover" : "Verschieben",
      "nursing_home" : "Pflegeheimdienst",
      "painter" : "Malerei",
      "personal_injury_lawyer" : "Personenschadensrecht",
      "personal_trainer" : "Persönliches Training",
      "pest_control" : "Schädlingsbekämpfung",
      "pet_adoption" : "Adoptionsdienste für Haustiere",
      "pet_boarding" : "Haustierpension",
      "pet_grooming" : "Haustierpflege",
      "pet_trainer" : "Haustiertraining",
      "photographer" : "Fotografie",
      "plumber" : "Sanitär",
      "pool_cleaner" : "Poolreinigung",
      "pool_contractor" : "Pool-Verträge",
      "preschool" : "Vorschulbildung",
      "psychologist" : "Psychologische Dienste",
      "real_estate_agent" : "Immobilien",
      "real_estate_lawyer" : "Immobilienrecht",
      "rehab" : "Rehabilitationsdienste",
      "roofer" : "Dachdeckerarbeiten",
      "sewage_pro" : "Abwassersystemdienste",
      "siding_pro" : "Verkleidung",
      "smart_home" : "Smart Home-Dienste",
      "snow_removal" : "Schneeräumungsdienste",
      "spa" : "Spa-Dienstleistungen",
      "tax_lawyer" : "Steuerrecht",
      "tax_specialist" : "Steuerdienste",
      "therapist" : "Therapie",
      "towing_pro" : "Pannenhilfe",
      "traffic_lawyer" : "Verkehrsrecht",
      "tree_service" : "Baumpflege",
      "tutor" : "Nachhilfeunterricht",
      "upholstery_cleaner" : "Polsterreinigung",
      "veterinarian" : "Tierärztliche Dienstleistungen",
      "videographer" : "Videodienste",
      "water_damage" : "Wasserschaden-Service",
      "weight_loss_service" : "Dienstleistungen zur Gewichtsabnahme",
      "window_cleaner" : "Fensterreinigung",
      "window_repair" : "Fensterservices",
      "windshield_repair_pro" : "Autoglas",
      "yoga_instructor" : "Yoga"
    },
    "job_types" : {
      "accountant_other" : "Andere",
      "bankruptcy_tax_litigation" : "Insolvenzsteuerstreitigkeiten",
      "bookkeeping" : "Buchhaltung",
      "business_consulting" : "Unternehmensberatung",
      "debt_collection_relief" : "Schuldeneinziehungserleichterung",
      "irs_representation_resolution" : "IRS-Vertretung und Streitbeilegung",
      "payroll" : "Gehaltsabrechnung",
      "tax_planning_business" : "Steuerplanungsgeschäft",
      "tax_planning_individual" : "Steuerplanung Einzelperson",
      "tax_return_business" : "Steuererstattungsunternehmen",
      "tax_return_individual" : "Steuererstattung Einzelperson",
      "trusts_estates_accounting" : "Rechnungswesen für Stiftungen und Nachlässe",
      "acupressure" : "Akupressur",
      "acupuncture" : "Akupunktur",
      "acupuncturist_other" : "Andere",
      "cupping" : "Schröpfen",
      "gua_sha" : "Gua Sha",
      "heat_therapy" : "Wärmetherapie",
      "herbal_therapy" : "Kräutertherapie",
      "infrared_therapy" : "Infrarot-Therapie",
      "moxibustion" : "Moxibustion",
      "qigong" : "Qigong",
      "shiatsu" : "Shiatsu",
      "tui_na" : "Tui Na",
      "air_duct_cleaning" : "Luftkanalreinigung",
      "air_duct_filter_replacement" : "Filterwechsel",
      "air_duct_other" : "Andere",
      "dryer_vent_cleaning" : "Reinigung der Trocknerentlüftung",
      "furnace_cleaning" : "Ofenreinigung",
      "indoor_air_quality_testing" : "Prüfung der Raumluftqualität",
      "alcohol_treatment_other" : "Andere",
      "animal_shelter_cat_adoption" : "Katzenadoption",
      "animal_shelter_dog_adoption" : "Hundeadoption",
      "animal_shelter_other" : "Andere",
      "animal_shelter_other_animal_adoption" : "Andere Tieradoption",
      "animal_shelter_other_veterinary_services" : "Andere tierärztliche Dienstleistungen",
      "animal_shelter_spay_neuter" : "Kastrieren oder Sterilisieren",
      "animal_shelter_vaccinations" : "Impfungen",
      "lost_stray_found_animals" : "Verlorene, streunende oder gefundene Tiere",
      "pet_license" : "Haustierlizenz",
      "pet_surrender" : "Abgabe von Haustieren",
      "appliance_other" : "Andere",
      "repair_dishwasher" : "Geschirrspüler reparieren",
      "repair_dryer" : "Trockner reparieren",
      "repair_freezer" : "Gefrierschrank reparieren",
      "repair_microwave" : "Mikrowelle reparieren",
      "repair_oven" : "Ofen reparieren",
      "repair_refrigerator" : "Reparatur Kühlschrank",
      "repair_refrigerator_freezer" : "Reparatur Kühl-/Gefrierschrank",
      "repair_stove_cooktop" : "Reparatur Herd/Kochfeld",
      "repair_stove_cooktop_oven" : "Reparatur Herd/Kochfeld/Backofen",
      "repair_washer" : "Reparatur Waschmaschine",
      "repair_washer_dryer" : "Reparatur Waschmaschine/Trockner",
      "3d_architectural_rendering" : "3D-Architekturvisualisierung",
      "adaptive_reuse_historical_renovation" : "Adaptive Wiederverwendung & Historische Renovierung",
      "architect_other" : "Andere",
      "architectural_designing" : "Architekturdesign",
      "architectural_engineering" : "Bauingenieurwesen",
      "building_code_analysis_permit_coordination" : "Code-Analyse und Genehmigungen",
      "consulting" : "Beratung",
      "home_building_improvement" : "Hausbau und Renovierung",
      "interior_design_architect" : "Innenarchitektur",
      "planning_zoning_approval_assistance" : "Planungs- und Zonengenehmigung",
      "project_managing_architect" : "Projektmanagement",
      "site_master_planning" : "Standort-Masterplanung",
      "assisted_living_housekeeping_and_laundry" : "Hauswirtschaft und Wäscheservice",
      "assisted_living_meal_services" : "Verpflegungsdienste",
      "assisted_living_memory_care" : "Gedächtnispflege",
      "assisted_living_other" : "Andere",
      "assisted_living_rehabilitation_services" : "Rehabilitationsdienste",
      "assisted_living_transportation" : "Transport",
      "assisted_living_wellness_programs" : "Wellness-Programme",
      "daily_living_assistance" : "Hilfe im Alltag",
      "medication_management" : "Medikamentenmanagement",
      "short_term_stays" : "Kurzzeitaufenthalte",
      "social_and_recreational_activities" : "Freizeitaktivitäten",
      "babysitter_other" : "Andere",
      "event_babysitting" : "Event-Babysitting",
      "homework_assistance" : "Hausaufgabenhilfe",
      "housekeeping_laundry" : "Hauswirtschaft und Wäscheservice",
      "meal_preparation" : "Essenszubereitung",
      "nanny_services" : "Kinderbetreuung",
      "overnight_babysitting" : "Babysitting über Nacht",
      "pick_up_and_drop_off" : "Abholung und Rückgabe",
      "shopping_errand" : "Einkaufen und Besorgungen",
      "special_needs_care" : "Betreuung für besondere Bedürfnisse",
      "virtual_babysitting" : "Virtuelles Babysitting",
      "agriculture_bankruptcy" : "Insolvenz in der Landwirtschaft",
      "bankruptcy_lawyer_other" : "Andere",
      "bankruptcy_litigation" : "Insolvenzstreitigkeiten",
      "chapter_11_bankruptcy" : "Kapitel 11 Insolvenz",
      "chapter_13_bankruptcy" : "Kapitel 13 Insolvenz",
      "chapter_7_bankruptcy" : "Kapitel 7 Insolvenz",
      "corporate_bankruptcy" : "Unternehmensinsolvenz",
      "creditor_harassment" : "Belästigung durch Gläubiger",
      "debt_settlement" : "Schuldenregulierung",
      "foreclosure_bankruptcy_lawyer" : "Zwangsvollstreckung",
      "personal_bankruptcy" : "Privatinsolvenz",
      "repossession" : "Rücknahme",
      "wage_garnishment" : "Lohnpfändung",
      "beauty_school_barbering" : "Friseurhandwerk",
      "beauty_school_business_management" : "Unternehmensführung",
      "beauty_school_cosmetology" : "Kosmetologie",
      "beauty_school_esthetics" : "Ästhetik",
      "beauty_school_hair_cutting" : "Haarschneiden",
      "beauty_school_hair_design" : "Haarstyling",
      "beauty_school_makeup" : "Make-up",
      "beauty_school_massage_therapy" : "Massagetherapie",
      "beauty_school_nail_technology" : "Nageltechnik",
      "beauty_school_other" : "Andere",
      "beauty_school_retail_training" : "Einzelhandelskurse",
      "banking_finance_law" : "Bankwesen & Finanzen",
      "business_lawyer_other" : "Andere",
      "business_licenses_permits" : "Unternehmenslizenzen und -genehmigungen",
      "business_litigation" : "Wirtschaftsrechtliche Streitigkeiten",
      "business_taxes" : "Unternehmenssteuern",
      "business_transactions_business_lawyer" : "Unternehmensumsatz",
      "commercial_bankruptcy" : "Gewerbliche Insolvenz",
      "commercial_contracts_business_lawyer" : "Handelsverträge",
      "employment_law_business_lawyer" : "Arbeitsrecht",
      "incorporation_restructuring" : "Gründung und Umstrukturierung",
      "insurance_law" : "Versicherungsrecht",
      "intellectual_property_law" : "Geistiges Eigentumsrecht",
      "mergers_acquisitions_business_lawyer" : "Fusionen und Übernahmen",
      "partnership_agreements_business_lawyer" : "Partnerschaftsvereinbarungen",
      "patents_copyrights_trademarks" : "Patente, Urheberrechte und Marken",
      "securities_law" : "Wertpapierrecht",
      "shareholder_disputes" : "Aktionärsstreitigkeiten",
      "air_and_cabin_filter" : "Luft- und Kabinenfilter",
      "battery" : "Batterie",
      "body_and_trim" : "Karosserie und Verkleidung",
      "brakes" : "Bremsen",
      "car_air_conditioning" : "Klimaanlage",
      "car_electrical" : "Elektrisch",
      "car_repair_other" : "Andere",
      "check_engine_light_diagnostic" : "Diagnose der Motorkontrollleuchte",
      "exhaust" : "Auspuff",
      "oil_change" : "Ölwechsel",
      "steering_suspension" : "Lenkung / Federung",
      "tires" : "Reifen",
      "transmission" : "Getriebe",
      "cabinetry" : "Schreinerei",
      "carpenter_other" : "Andere",
      "decking" : "Terrassendielen",
      "drywalling" : "Trockenbau",
      "fencing" : "Einzäunung",
      "general_installations" : "Allgemeine Installationen",
      "general_repairs_maintenance" : "Allgemein Service- und Wartungsarbeiten",
      "remodeling" : "Renovierung",
      "shelving_storage" : "Regale und Lagerung",
      "carpet_cleaning_other" : "Andere",
      "clean_area_rugs" : "Teppichreinigung",
      "clean_carpet" : "Teppichreinigung",
      "clean_drapes_and_curtains" : "Reinigung von Vorhängen und Gardinen",
      "clean_upholstery" : "Polstermöbel reinigen",
      "remove_pet_stains_and_odors" : "Entfernen von Flecken und Gerüchen von Haustieren",
      "after_school_care" : "Nachmittagsbetreuung",
      "all_hours_daycare" : "Rund-um-die-Uhr-Kindertagesstätte",
      "bilingual_daycare" : "Zweisprachige Kindertagesstätte",
      "child_care_other" : "Andere",
      "drop_in_daycare" : "Kindertagesstätte",
      "full_time_daycare" : "Ganztägige Kindertagesstätte",
      "in_home_daycare" : "Tagesbetreuung im Haus",
      "infant_programs" : "Programme für Säuglinge",
      "part_time_daycare" : "Teilzeit-Kindertagesstätte",
      "pre_kindergarten_programs" : "Vorschulprogramme",
      "preschool_programs" : "Vorschulprogramme",
      "school_age_programs" : "Programme für Schulkinder",
      "special_needs_daycare" : "Kindertagesstätte für besondere Bedürfnisse",
      "summer_daycare" : "Sommerbetreuung",
      "toddler_programs" : "Programme für Kleinkinder",
      "weekend_daycare" : "Wochenendbetreuung",
      "chiropractor_acupuncture" : "Akupunktur",
      "chiropractor_chiropractic" : "Chiropraktik",
      "chiropractor_massage_therapy" : "Massagetherapie",
      "chiropractor_other" : "Andere",
      "diagnosis" : "Diagnose",
      "eastern_medicine" : "Östliche Medizin",
      "exercise_counseling" : "Trainingsberatung",
      "pain_management" : "Schmerzmanagement",
      "physical_therapy" : "Physiotherapie",
      "spinal_adjustments" : "Wirbelsäulenanpassungen",
      "sports_medicine" : "Sportmedizin",
      "cleaner_other" : "Andere",
      "deep_clean" : "Tiefenreinigung",
      "moving_clean" : "Umzugsreinigung",
      "office_clean" : "Büroreinigung",
      "standard_clean" : "Normalreinigung",
      "assignment_of_contract" : "Vertragsabtretung",
      "business_transactions_contract_lawyer" : "Unternehmensumsatz",
      "commercial_contracts_contract_lawyer" : "Handelsverträge",
      "contract_dispute" : "Vertragskonflikt",
      "contract_lawyer_other" : "Andere",
      "contract_negotiation" : "Vertragsverhandlung",
      "contract_review" : "Vertragsbewertung",
      "employment_contracts_contract_lawyer" : "Arbeitsverträge",
      "franchise_agreements" : "Franchiseverträge",
      "mergers_acquisitions_contract_lawyer" : "Fusionen und Übernahmen",
      "non_disclosure_agreements_contract_lawyer" : "Geheimhaltungsvereinbarungen",
      "partnership_agreements_contract_lawyer" : "Partnerschaftsvereinbarungen",
      "power_of_attorney_contract_lawyer" : "Vollmacht",
      "security_agreements" : "Sicherheitsvereinbarungen",
      "warranties" : "Garantien",
      "bathroom_countertops" : "Arbeitsplatten für das Badezimmer",
      "bathroom_wall_panels" : "Wandpaneele für das Badezimmer",
      "countertop_design" : "Arbeitsplattendesign",
      "countertop_installation" : "Arbeitsplatteninstallation",
      "countertop_pro_other" : "Andere",
      "fireplace_facade" : "Kaminfassade",
      "granite_countertops" : "Granit-Arbeitsplatten",
      "kitchen_countertops" : "Küchen-Arbeitsplatten",
      "kitchen_wall_panels" : "Küchenwandpaneele",
      "laminate_countertops" : "Laminat-Arbeitsplatten",
      "marble_countertops" : "Marmor-Arbeitsplatten",
      "quartz_countertops" : "Quarz-Arbeitsplatten",
      "remodeling_countertop_pro" : "Renovierung",
      "repair_maintenance_countertop_pro" : "Reparatur und Wartung",
      "stone_slab_countertops" : "Arbeitsplatten aus Steinplatten",
      "tile_countertops" : "Arbeitsplatten aus Fliesen",
      "corporate_representation" : "Unternehmensvertretung",
      "criminal_immigration_defense" : "Strafrechtliche Einwanderungsverteidigung",
      "criminal_lawyer_other" : "Andere",
      "domestic_violence" : "Häusliche Gewalt",
      "drug_possession" : "Drogenbesitz",
      "duis_reckless_driving" : "Fahren unter Einfluss von Alkohol oder Drogen und rücksichtsloses Autofahren",
      "expungement" : "Löschung",
      "federal_crimes" : "Bundeskriminalität",
      "felonies" : "Schwere Verbrechen",
      "petty_crimes_misdemeanors" : "Bagatelldelikte und Ordnungswidrigkeiten",
      "restraining_orders" : "Einstweilige Verfügungen",
      "sex_offenses" : "Sexualdelikte",
      "three_strikes_law" : "Three-Strikes-Gesetz",
      "dance_instructor_african" : "Afrikanisch",
      "dance_instructor_ballet" : "Ballett",
      "dance_instructor_ballroom" : "Ballsaal",
      "dance_instructor_belly" : "Bauch",
      "dance_instructor_bollywood" : "Bollywood",
      "dance_instructor_contemporary" : "Zeitgenössisch",
      "dance_instructor_folk_traditional" : "Folk und Traditionell",
      "dance_instructor_hip_hop" : "Hip Hop",
      "dance_instructor_jazz" : "Jazz",
      "dance_instructor_kids_classes" : "Kinderkurse",
      "dance_instructor_latin" : "Latein",
      "dance_instructor_modern" : "Modern",
      "dance_instructor_other" : "Andere",
      "dance_instructor_tap" : "Tippen",
      "dance_instructor_wedding" : "Hochzeit",
      "disability_hearings" : "Anhörungen zu Erwerbsunfähigkeit",
      "disability_lawyer_other" : "Andere",
      "long_term_disability" : "Langfristige Erwerbsunfähigkeit",
      "short_term_disability" : "Kurzfristige Erwerbsunfähigkeit",
      "social_security_disability_insurance" : "Sozialversicherung für Erwerbsunfähigkeit",
      "ssa_claim_reconsideration" : "Neubewertung des SSA-Anspruchs",
      "ssa_disability_appeals" : "Berufungsverfahren bei der SSA bei Erwerbsunfähigkeit",
      "ssa_disability_applications" : "Anträge auf Leistungen bei Erwerbsunfähigkeit bei der SSA",
      "ssa_disability_benefits" : "SSA-Leistungen bei Erwerbsunfähigkeit",
      "ssa_family_benefits" : "SSA-Familienleistungen",
      "ssa_impairment_listings" : "SSA-Liste der Beeinträchtigungen",
      "supplemental_security_income" : "Ergänzende Sicherheitsleistungen",
      "veterans_disability_benefits" : "Leistungen bei Erwerbsunfähigkeit für Veteranen",
      "workers_compensation_disability_lawyer" : "Arbeitnehmerentschädigung",
      "behind_the_wheel_lessons" : "Fahrstunden",
      "commercial_license_training" : "Kurse für gewerbliche Lizenzen",
      "defensive_driving_lessons" : "Ausbildung zum Erwerb einer gewerblichen Fahrerlaubnis",
      "drivers_education_classes" : "Fahrschulunterricht",
      "driving_instructor_other" : "Andere",
      "manual_transmission_lessons" : "Schaltgetriebe-Unterricht",
      "motorcycle_lessons" : "Motorradunterricht",
      "traffic_school" : "Verkehrsschule",
      "dui_dwi_dui_lawyer" : "Fahren unter Einfluss psychoaktiver Substanzen (DUI/DWI)",
      "dui_injuries_dui_lawyer" : "Fahren unter Alkoholeinfluss mit Verletzung",
      "dui_lawyer_other" : "Andere",
      "dui_with_accident" : "Fahren unter Alkoholeinfluss mit Unfall",
      "felony_dui" : "Schweres Verbrechen unter Alkoholeinfluss",
      "invalid_tests" : "Ungültige Tests",
      "multiple_offenses" : "Mehrere Verstöße",
      "reckless_driving_dui_lawyer" : "Rücksichtsloses Fahren",
      "underage_dui" : "Fahren unter Alkoholeinfluss von Minderjährigen",
      "electric_car_charger" : "Elektroauto-Ladegerät installieren",
      "electrician_other" : "Andere",
      "electrician_remodeling" : "Renovierung",
      "install_fan" : "Lüfter installieren",
      "install_ground_wire" : "Erdungskabel installieren",
      "install_light_fixtures" : "Leuchten installieren",
      "install_outdoor_lighting" : "Außenbeleuchtung installieren",
      "install_outlets_switches" : "Steckdosen oder Schalter installieren",
      "install_security_system" : "Sicherheitssystem installieren",
      "relocate_outlets_switches" : "Steckdosen oder Schalter verlegen",
      "repair_fan" : "Lüfter reparieren",
      "repair_light_fixtures" : "Reparatur von Beleuchtungskörpern",
      "repair_outlets_switches" : "Reparatur von Steckdosen oder Schaltern",
      "repair_panel" : "Panel reparieren",
      "replace_upgrade_panel" : "Panel ersetzen oder verbessern",
      "restore_power" : "Stromversorgung wiederherstellen",
      "energy_efficiency_pro_other" : "Andere",
      "charitable_giving" : "Spenden für wohltätige Zwecke",
      "contests_litigation" : "Wettbewerbe/Rechtsstreitigkeiten",
      "deeds" : "Urkunden",
      "estate_lawyer_other" : "Andere",
      "estate_planning_lawyer" : "Nachlassplanung",
      "guardianship_estate_lawyer" : "Vormundschaft",
      "medical_power_of_attorney" : "Medizinische Vollmacht",
      "power_of_attorney_estate_lawyer" : "Vollmacht",
      "probate_estate_lawyer" : "Anwalt für Nachlassangelegenheiten",
      "trusts" : "Vertrauensstellungen",
      "wills" : "Testamente",
      "anniversary_planner" : "Jubiläum",
      "baby_shower_planner" : "Babyparty",
      "bar_and_bat_mitzvah_planner" : "Bar und Bat Mitzvah",
      "birthday_party" : "Geburtstagsparty",
      "children_party" : "Kinderparty",
      "corporate_and_conference_planner" : "Firmen und Kongresse",
      "event_planner_other" : "Andere",
      "quinceanera_planner" : "Quinceanera",
      "religious_event" : "Religiöse Veranstaltung",
      "retirement_party" : "Ruhestandsfeier",
      "school_event" : "Schulveranstaltung",
      "theme_party" : "Mottoparty",
      "wedding_and_engagement_planner" : "Hochzeit und Verlobung",
      "adoption" : "Adoption",
      "child_support" : "Kindesunterhalt",
      "contested_divorce" : "Streitige Scheidung",
      "debt_division" : "Schuldenabteilung",
      "family_lawyer_other" : "Andere",
      "guardianship_family_lawyer" : "Vormundschaft",
      "mediation_family_lawyer" : "Mediation",
      "modifications_of_orders" : "Änderung von Bestellungen",
      "parent_timesharing" : "Eltern-Timesharing",
      "paternity" : "Vaterschaft",
      "prenuptial_postnuptial_agreements" : "Ehevorbereitungen und Ehevereinbarungen",
      "probate_family_lawyer" : "Nachlassverfahren",
      "property_divisions" : "Vermögensaufteilung",
      "protective_orders_domestic_violence_issues" : "Einstweilige Verfügungen",
      "spousal_support_alimony" : "Ehegattenunterhalt & Alimente",
      "uncontested_divorce" : "Einvernehmliche Scheidung",
      "custom_construction" : "Sonderanfertigung",
      "fence_design" : "Zaundesign",
      "fencing_other" : "Andere",
      "installation_fencing_pro" : "Zaunmontage",
      "repairs_maintenance_fencing_pro" : "Reparaturen und Wartung",
      "education_savings" : "Bildungsersparnisse",
      "estate_financial_planning" : "Nachlassplanung",
      "financial_planning" : "Finanzplanung",
      "financial_planning_other" : "Andere",
      "home_purchase" : "Hauskauf",
      "insurance" : "Versicherung",
      "investment_advising" : "Anlageberatung",
      "retirement_savings" : "Ruhestand",
      "tax_planning" : "Steuerplanung",
      "advanced_cardiac_life_support" : "Erweiterte Herz-Lungen-Wiederbelebung",
      "aed_defibrillator" : "AED - Defibrillator",
      "basic_life_support" : "Grundlegende Wiederbelebung",
      "cpr" : "CPR",
      "first_aid" : "Erste Hilfe",
      "first_aid_trainer_other" : "Andere",
      "pediatric_advanced_life_support" : "Pädiatrische erweiterte Wiederbelebung",
      "pediatric_cpr_first_aid" : "Kinder-CPR und Erste Hilfe",
      "pet_cpr_first_aid" : "Erste Hilfe und Wiederbelebung für Haustiere",
      "wilderness_first_aid" : "Erste Hilfe in der Wildnis",
      "baseboards" : "Sockelleisten",
      "carpet" : "Teppich",
      "flooring_other" : "Andere",
      "hardwood" : "Hartholz",
      "installation_flooring_pro" : "Fußböden verlegen",
      "marble" : "Marmor",
      "polishing" : "Bodenpolitur",
      "refinishing" : "Bodensanierung",
      "repair_maintenance_flooring_pro" : "Bodenreparatur und -wartung",
      "stair_flooring" : "Treppenbelag",
      "tile" : "Fliese",
      "wood_floor_sanding" : "Schleifen von Holzböden",
      "basement_waterproofing" : "Kellerabdichtung",
      "crawl_spaces" : "Kriechkellerfundament",
      "foundation_drainage" : "Fundamentdrainage",
      "foundation_installation" : "Fundamentinstallation",
      "foundation_pro_other" : "Andere",
      "foundation_raising" : "Fundamenterhöhung",
      "repairs_maintenance_foundation_pro" : "Reparaturen und Wartung",
      "slab_foundation" : "Plattenfundament",
      "steel_pier_pilings" : "Stahlpfeilerpfähle",
      "water_moisture_control" : "Wasser- und Feuchtigkeitskontrolle",
      "burials" : "Bestattungen",
      "caskets" : "Särge",
      "cremation" : "Einäscherung",
      "funeral_home_flowers" : "Blumen",
      "funeral_home_other" : "Andere",
      "funeral_home_transportation_transfers" : "Transport und Überstellungen",
      "funeral_home_veteran_services" : "Veteranendienste",
      "funerals" : "Beerdigungen",
      "gravestones" : "Grabsteine",
      "grief_services" : "Trauerdienste",
      "memorials" : "Gedenkstätten",
      "urns" : "Urnen",
      "garage_door_other" : "Andere",
      "general_maintenance" : "Allgemeine Wartung",
      "install_garage_door" : "Garagentorinstallation",
      "install_opener" : "Opener installieren",
      "repair_cables" : "Kabel reparieren",
      "repair_garage_door" : "Garagentor reparieren",
      "repair_gate" : "Reperatur von Toren",
      "repair_rollers_tracks" : "Reparatur von Rollen und Laufbahnen",
      "replace_door_panels" : "Türverkleidungen ersetzen",
      "replace_opener" : "Öffner ersetzen",
      "replace_springs" : "Federn ersetzen",
      "accessory_buildings" : "Nebengebäude",
      "bathroom_remodel" : "Badezimmerrenovierung",
      "decks_patio" : "Terrassen und Patios",
      "exterior_finishing" : "Außenverkleidung",
      "foundations_concrete" : "Fundamente und Beton",
      "general_contractor_commercial_projects" : "Kommerzielle Projekte",
      "general_contractor_other" : "Andere",
      "home_addition" : "Hausanbau",
      "home_building" : "Hausbau",
      "home_remodel_renovation" : "Hausumbau und Renovierung",
      "interior_finishing" : "Innenausbau",
      "kitchen_remodel" : "Küchenrenovierung",
      "roofing" : "Dachdeckerarbeiten",
      "assemble_furniture" : "Möbel zusammenbauen",
      "clean_gutters" : "Dachrinnen reinigen",
      "handyman_other" : "Andere",
      "install_drywall" : "Trockenbau",
      "install_flooring" : "Bodenbelag verlegen",
      "install_tile" : "Fliesenlegen",
      "install_water_fixtures" : "Wasserarmaturen installieren",
      "mount_tv" : "TV montieren",
      "paint_indoors" : "Innenräume streichen",
      "paint_outdoors" : "Außenbereiche streichen",
      "repair_drywall" : "Trockenbau reparieren",
      "repair_flooring" : "Bodenbelag reparieren",
      "repair_water_fixtures" : "Wasserarmaturen reparieren",
      "replace_tile" : "Fliese ersetzen",
      "buyer_seller_inspection" : "Käufer-Verkäufer-Inspektion",
      "commercial_properties" : "Gewerbeimmobilien",
      "fire_safety" : "Brandschutz",
      "fireplace_chimney" : "Kamin und Schornstein",
      "full_home_inspection" : "Vollständige Hausinspektion",
      "home_inspector_electrical" : "Elektrisch",
      "home_inspector_foundation" : "Grundlage",
      "home_inspector_hvac" : "Heizungs-, Lüftungs- und Klimatechnik",
      "home_inspector_mold" : "Schimmel",
      "home_inspector_new_construction" : "Neubau",
      "home_inspector_other" : "Andere",
      "home_inspector_plumbing" : "Sanitär",
      "home_inspector_roof" : "Dach",
      "home_inspector_structural" : "Strukturell",
      "home_warranty" : "Hausgarantie",
      "water_testing" : "Wassertests",
      "well_or_septic_system" : "Brunnen oder Klärgrube",
      "wood_insects" : "Holz und Insekten",
      "access_control" : "Zugangskontrolle",
      "alarm_systems" : "Alarmsysteme",
      "commercial_security_systems" : "Kommerzielle Sicherheitssysteme",
      "fire_smoke_detection" : "Brand- und Raucherkennung",
      "home_security_doors" : "Türen",
      "home_security_locks" : "Schlösser",
      "home_security_other" : "Andere",
      "home_security_windows" : "Fenster",
      "monitoring_services" : "Überwachungsdienste",
      "residential_security_systems" : "Sicherheitssysteme für Wohngebäude",
      "smart_home_integration" : "Smart-Home-Integration",
      "video_surveillance" : "Videoüberwachung",
      "audio_video_installation" : "Audio-Video-Installation",
      "commercial_projects" : "Kommerzielle Projekte",
      "home_theater_design" : "Heimkino-Design",
      "home_theater_lighting" : "Beleuchtung",
      "home_theater_other" : "Andere",
      "home_theater_smart_home_integration" : "Smart-Home-Integration",
      "install_tv" : "TV installieren",
      "network_it_services" : "Netzwerk- und IT-Dienstleistungen",
      "outdoor_installations" : "Außeninstallationen",
      "soundproofing" : "Schalldämmung",
      "whole_house_audio_video" : "Audio-Video für das ganze Haus",
      "ac_maintenance" : "AC-Wartung",
      "clean_ducts_vents" : "Reinigung von Kanälen und Lüftungsöffnungen",
      "ductless_heating_and_ac_services" : "Kanallose Heizungs- und Klimaanlagendienste",
      "heating_maintenance" : "Heizungswartung",
      "hvac_maintenance" : "HVAC-Wartung",
      "hvac_other" : "Andere",
      "install_ac" : "AC installieren",
      "install_ducts_vents" : "Installieren von Kanälen und Lüftungsöffnungen",
      "install_heating_system" : "Heizsystem installieren",
      "install_thermostat" : "Thermostat installieren",
      "repair_ac" : "AC reparieren",
      "repair_ducts_vents" : "Reparatur von Kanälen und Lüftungsöffnungen",
      "repair_heating_system" : "Heizsystem reparieren",
      "repair_hvac" : "HVAC reparieren",
      "repair_thermostat" : "Thermostat reparieren",
      "asylum" : "Asyl",
      "citizenship" : "Staatsbürgerschaft",
      "deportation" : "Abschiebung",
      "family_based_immigration" : "Familienbasierte Einwanderung",
      "green_card" : "Green Card",
      "immigration_lawyer_other" : "Andere",
      "investment_visa" : "Investorenvisum",
      "outbound_work_permits" : "Arbeitsgenehmigungen für Auslandsaufenthalte",
      "student_visa" : "Studentenvisum",
      "visitor_visa" : "Besuchervisum",
      "work_visa" : "Arbeitsvisum",
      "appliance_selection" : "Geräteauswahl",
      "cabinetry_molding_hardware_design" : "Schrank- und Hardwaredesign",
      "decorating" : "Dekorieren",
      "door_design" : "Türdesign",
      "exterior_building_design" : "Außengebäudedesign",
      "flooring_selection" : "Auswahl der Bodenbeläge",
      "interior_designer_other" : "Andere",
      "landscaping_design" : "Landschaftsgestaltung",
      "lighting_design" : "Beleuchtungsdesign",
      "multifamily_housing_design" : "Mehrfamilienhaus-Design",
      "room_planning" : "Raumplanung",
      "stone_brick_stucco_design" : "Stein-, Ziegel- und Stuckdesign",
      "window_design" : "Fensterdesign",
      "advertisements" : "Anzeigen",
      "copyright" : "Urheberrecht",
      "export_control" : "Exportkontrolle",
      "franchises" : "Franchise",
      "international_ip" : "Internationale IP",
      "ip_lawyer_other" : "Andere",
      "ip_strategy" : "IP-Strategie",
      "ip_transactions" : "IP-Transaktionen",
      "licensing" : "Lizenzierung",
      "litigation_ip_lawyer" : "Rechtsstreitigkeit",
      "non_disclosure_agreements_ip_lawyer" : "Geheimhaltungsvereinbarungen",
      "patents" : "Patente",
      "technology_transfer" : "Technologietransfer",
      "trade_secrets" : "Geschäftsgeheimnisse",
      "trademarks" : "Markenzeichen",
      "appliance_removal" : "Entfernen von Geräten",
      "construction_waste_removal" : "Bauschuttentsorgung",
      "donation_pickup" : "Spendenabholung",
      "electronic_waste_removal" : "Entsorgung von Elektroschrott",
      "furniture_removal" : "Möbelentsorgung",
      "general_junk_removal" : "Allgemeine Müllentsorgung",
      "hazardous_waste_removal" : "Entsorgung gefährlicher Abfälle",
      "house_garage_cleanout" : "Haus-/Garagenreinigung",
      "junk_removal_other" : "Andere",
      "yard_waste_removal" : "Entsorgung von Gartenabfällen",
      "employment_contracts_labor_lawyer" : "Arbeitsverträge",
      "employment_law_labor_lawyer" : "Arbeitsrecht",
      "exempt_employee_status" : "Status als freigestellter Arbeitnehmer",
      "labor_law" : "Arbeitsrecht",
      "labor_lawyer_other" : "Andere",
      "labor_negotiations" : "Arbeitsverhandlungen",
      "privacy_rights" : "Datenschutzrechte",
      "sexual_harassment" : "Sexuelle Belästigung",
      "unpaid_overtime" : "Unbezahlte Überstunden",
      "whistle_blowing" : "Whistleblowing",
      "workers_compensation_labor_lawyer" : "Arbeitnehmerentschädigung",
      "wrongful_termination" : "Unrechtmäßige Kündigung",
      "artificial_turf_installation" : "Kunstraseninstallation",
      "concrete_masonry" : "Betonmauerwerk",
      "driveway_landscaping" : "Einfahrtsgestaltung",
      "garden_decorations" : "Gartendekorationen",
      "grading_resloping" : "Planieren und Neuanlegen der Neigung",
      "hardscapes" : "Hardscapes",
      "landscape_design" : "Landschaftsdesign",
      "landscape_installations" : "Landschaftsinstallationen",
      "landscaper_other" : "Andere",
      "outdoor_steps" : "Außentreppen",
      "outdoor_water_feature" : "Wasserspiele im Freien",
      "paving_driveway_walkway" : "Einfahrt- oder Gehwegpflasterung",
      "retaining_walls" : "Stützmauern",
      "sidewalk_walkway_landscaping" : "Gehweggestaltung",
      "sod_seeding" : "Rollrasen und Aussaat",
      "stone_masonry" : "Steinmetzarbeiten",
      "arabic" : "Arabisch",
      "english" : "English",
      "french" : "French",
      "german" : "German",
      "hebrew" : "Hebräisch",
      "italian" : "Italian",
      "japanese" : "Japanisch",
      "korean" : "Koreanisch",
      "language_instructor_other" : "Andere",
      "mandarin" : "Mandarin",
      "portuguese" : "Portugiesisch",
      "russian" : "Russisch",
      "sign_language" : "Gebärdensprache",
      "spanish" : "Spanish",
      "irrigation_system_repair_maintenance" : "Reparatur/Wartung von Bewässerungssystemen",
      "lawn_care_other" : "Andere",
      "lawn_mowing_maintenance" : "Rasenmähen/-pflege",
      "lawn_pest_control" : "Schädlingsbekämpfung im Rasen",
      "mulching" : "Mulchen",
      "seeding" : "Aussaat",
      "sod_installation" : "Rollrasenverlegung",
      "weed_control" : "Unkrautbekämpfung",
      "yard_cleanup" : "Hofreinigung",
      "appeals" : "Berufungen",
      "case_assessment_litigation_lawyer" : "Fallbewertung",
      "civil_litigation" : "Zivilprozess",
      "commercial_litigation" : "Handelsstreitigkeiten",
      "contracts_and_agreements" : "Verträge und Vereinbarungen",
      "criminal_litigation" : "Strafrechtliche Verfahren",
      "litigation_lawyer_other" : "Andere",
      "mediation_litigation_lawyer" : "Mediation",
      "settlements" : "Vergleiche",
      "building_lockout" : "Gebäudesperre",
      "copy_building_key" : "Gebäudeschlüssel kopieren",
      "copy_vehicle_key" : "Fahrzeugschlüssel kopieren",
      "install_hardware" : "Hardware installieren",
      "locksmith_other" : "Andere",
      "new_key_fob" : "Neuer Funkschlüssel",
      "rekey_lock" : "Schloss neu codieren",
      "repair_hardware" : "Hardware reparieren",
      "vehicle_lockout" : "Fahrzeugsperre",
      "consent_issues" : "Einwilligungsprobleme",
      "diagnosis_errors" : "Diagnosefehler",
      "malpractice_lawyer_other" : "Andere",
      "medical_negligence" : "Ärztliche Fahrlässigkeit",
      "treatment_errors" : "Behandlungsfehler",
      "massage_center_other" : "Andere",
      "massage_school_advanced_neuromuscular_therapy" : "Fortgeschrittene neuromuskuläre Therapie",
      "massage_school_business_and_ethics" : "Wirtschaft und Ethik",
      "massage_school_clinical_therapies" : "Klinische Therapien",
      "massage_school_continuing_education" : "Weiterbildung",
      "massage_school_deep_tissue_massage" : "Tiefengewebsmassage",
      "massage_school_energetics" : "Energetik",
      "massage_school_hydrotherapy" : "Hydrotherapie",
      "massage_school_lymphatic_massage" : "Lymphdrainage",
      "massage_school_online_massage_therapy" : "Online-Massagetherapie",
      "massage_school_other" : "Andere",
      "massage_school_prenatal_massage" : "Pränatale Massage",
      "massage_school_sports_massage" : "Sportmassage",
      "massage_school_student_massage_clinic" : "Studentische Massageklinik",
      "massage_school_swedish_massage" : "Schwedische Massage",
      "massage_theory" : "Massagetheorie",
      "massage_therapy_training" : "Massagetherapie-Ausbildung",
      "in_state_move" : "Umzug innerhalb des Bundeslandes",
      "local_move" : "Lokaler Umzug",
      "mover_other" : "Andere",
      "moving_junk_removal" : "Müllentsorgung",
      "moving_storage" : "Speicher",
      "out_of_state_move" : "Umzug in ein anderes Bundesland",
      "oversized_item_move" : "Transport übergroßer Gegenstände",
      "packing_unpacking" : "Verpacken / Auspacken",
      "senior_move" : "Seniorenumzug",
      "vehicle_transport" : "Fahrzeugtransport",
      "cardiac_care" : "Kardiologische Versorgung",
      "general_medical_care" : "Allgemeine medizinische Versorgung",
      "hospice" : "Hospiz",
      "iv_therapy" : "Infusionstherapie",
      "nursing_home_meal_services" : "Verpflegungsdienste",
      "nursing_home_memory_care" : "Gedächtnispflege",
      "nursing_home_other" : "Andere",
      "nursing_home_pain_management" : "Schmerzmanagement",
      "nursing_home_rehabilitation_services" : "Rehabilitationsdienste",
      "nursing_home_wellness_programs" : "Wellness-Programme",
      "outpatient_rehabilitation" : "Ambulante Rehabilitation",
      "post_hospital_care" : "Pflege nach dem Krankenhausaufenthalt",
      "respiratory_and_pulmonary_care" : "Atemwegs- und Lungenversorgung",
      "senior_activity_programs" : "Aktivitätsprogramme für Senioren",
      "short_term_rehabilitation" : "Kurzzeitrehabilitation",
      "wound_care" : "Wundversorgung",
      "exterior_painting" : "Außenanstrich",
      "interior_painting" : "Innenanstrich",
      "paint_cabinets" : "Schränke streichen",
      "paint_doors" : "Türen streichen",
      "painter_other" : "Andere",
      "repair_water_damage" : "Wasserschaden reparieren",
      "staining" : "Färbung",
      "assault_battery" : "Körperverletzung und Tätlichkeit",
      "auto_accidents" : "Autounfälle",
      "bicycle_accidents" : "Fahrradunfälle",
      "catastrophic_injuries" : "Katastrophale Verletzungen",
      "dog_bites" : "Hundebisse",
      "dui_injuries_personal_injury_lawyer" : "Verletzungen durch Trunkenheit am Steuer",
      "medical_malpractice" : "Ärztlicher Kunstfehler",
      "motorcycle_accidents" : "Motorradunfälle",
      "pain_suffering" : "Schmerz und Leid",
      "pedestrian_accidents" : "Fußgängerunfälle",
      "personal_injury_lawyer_other" : "Andere",
      "product_liability" : "Produkthaftung",
      "slip_fall" : "Ausrutschen und Stürzen",
      "uninsured_motorist_claims" : "Ansprüche aus der Kfz-Versicherung",
      "workers_compensation_personal_injury_lawyer" : "Arbeitnehmerentschädigung",
      "wrongful_death" : "Fahrlässiger Tod",
      "aerobics" : "Aerobic",
      "athletic_performance" : "Sportliche Leistung",
      "circuit_training" : "Zirkeltraining",
      "endurance" : "Ausdauer",
      "fitness_assessment" : "Fitnesstest",
      "hiit" : "HIIT",
      "nutritional_counseling" : "Ernährungsberatung",
      "personal_trainer_other" : "Andere",
      "strength_conditioning" : "Kraft- und Konditionstraining",
      "weight_loss" : "Gewichtsverlust",
      "yoga" : "Yoga",
      "ants" : "Ameisen",
      "bed_bugs" : "Bettwanzen",
      "bees" : "Bienen",
      "cockroaches" : "Kakerlaken",
      "fleas_or_mites" : "Flöhe oder Milben",
      "hornets_or_wasps" : "Hornissen oder Wespen",
      "mosquitoes" : "Mücken",
      "pest_control_other" : "Andere",
      "pest_inspection" : "Inspektion",
      "rodents" : "Nagetiere",
      "spiders" : "Spinnen",
      "termites" : "Termiten",
      "wildlife" : "Wildtiere",
      "pet_adoption_birds" : "Vögel",
      "pet_adoption_cats" : "Katzen",
      "pet_adoption_dogs" : "Hunde",
      "pet_adoption_farm_animals" : "Nutztiere",
      "pet_adoption_fish" : "Fisch",
      "pet_adoption_other" : "Andere",
      "pet_adoption_reptiles" : "Reptilien",
      "pet_adoption_small_mammals" : "Kleine Säugetiere",
      "pet_adoption_special_needs_animals" : "Tiere mit besonderen Bedürfnissen",
      "cat_boarding" : "Katzenpension",
      "cat_grooming" : "Katzenpflege",
      "cat_sitting_in_home" : "Katzenbetreuung (zu Hause)",
      "dog_boarding" : "Hundepension",
      "dog_boarding_with_training" : "Hundepension mit Training",
      "dog_daycare" : "Hundetagesstätte",
      "dog_grooming" : "Hundepflege",
      "dog_sitting_in_home" : "Hundebetreuung (zu Hause)",
      "dog_training" : "Hundetraining",
      "dog_walking" : "Gassigehen",
      "other_pet_boarding" : "Andere Haustierunterkünfte",
      "other_pet_daycare" : "Andere Haustier-Tagesbetreuung",
      "other_pet_grooming" : "Andere Haustierpflege",
      "other_pet_sitting_in_home" : "Andere Haustierbetreuung (zu Hause)",
      "pet_boarding_other" : "Andere",
      "cat_bathing" : "Katzenbaden",
      "cat_ear_cleaning" : "Katzenohrenreinigung",
      "cat_grooming_and_styling" : "Katzenpflege und Styling",
      "cat_nail_trimming" : "Katzennagelschneiden",
      "dog_anal_gland_expression" : "Ausdruck der Analdrüsen bei Hunden",
      "dog_bathing_and_blow_dry" : "Hundebaden und Föhnen",
      "dog_ear_cleaning" : "Ohrenreinigung bei Hunden",
      "dog_flea_and_tick_treatment" : "Floh- und Zeckenbehandlung bei Hunden",
      "dog_full_service_grooming" : "Vollständige Hundepflege",
      "dog_grooming_and_styling" : "Hundepflege und Styling",
      "dog_nail_trimming" : "Krallenschneiden bei Hunden",
      "dog_teeth_brushing" : "Zahnreinigung für Hunde",
      "pet_grooming_other" : "Andere",
      "aggressive_dog_training" : "Training für aggressive Hunde",
      "behavior_modification" : "Verhaltensmodifikation",
      "obedience_training" : "Gehorsamkeitstraining",
      "offleash_training" : "Training ohne Leine",
      "pet_trainer_other" : "Andere",
      "puppy_training" : "Welpentraining",
      "service_animal_training" : "Ausbildung von Servicetieren",
      "sport_trick_training" : "Sport- oder Tricktraining",
      "training_other_animals" : "Training für andere Tiere",
      "corporate_photo" : "Unternehmen",
      "events_and_parties_photo" : "Veranstaltungen und Partys",
      "family_and_group_photo" : "Familie und Gruppe",
      "headshots_and_portraits" : "Headshots und Porträts",
      "individual_photo" : "Einzelperson",
      "maternity_and_newborn_photo" : "Mutterschaft und Neugeborenes",
      "photographer_other" : "Andere",
      "product_photo" : "Produkt",
      "real_estate_photo" : "Immobilien",
      "school_portraits" : "Schulporträts",
      "wedding_and_engagement_photo" : "Hochzeit und Verlobung",
      "find_leak" : "Leck finden und reparieren",
      "install_faucet" : "Wasserhahn installieren",
      "install_garbage_disposal" : "Müllentsorgung installieren",
      "install_shower" : "Dusche installieren",
      "install_toilet" : "Toilette installieren",
      "install_water_heater" : "Warmwasserbereiter installieren",
      "plumbing_other" : "Andere",
      "repair_faucet" : "Wasserhahn reparieren",
      "repair_garbage_disposal" : "Müllentsorgung reparieren",
      "repair_outdoor_systems" : "Außensysteme reparieren",
      "repair_pipe" : "Rohr reparieren",
      "repair_sewer" : "Abwasserkanal reparieren",
      "repair_shower" : "Dusche reparieren",
      "repair_toilet" : "Toilette reparieren",
      "repair_water_heater" : "Warmwasserbereiter reparieren",
      "unclog_drain" : "Abfluss freimachen",
      "commercial_pool_cleaning_maintenance" : "Gewerbliche Poolreinigung und -wartung",
      "equipment_maintenance_repair" : "Gerätewartung und -reparatur",
      "one_time_pool_cleaning" : "Einmalige Pool-Reinigung",
      "ongoing_pool_cleaning" : "Laufende Poolreinigung",
      "pool_cleaner_other" : "Andere",
      "pool_cleaner_water_features" : "Wassereigenschaften",
      "seasonal_opening_closing" : "Saisonale Öffnung und Schließung",
      "spa_hot_tub_cleaning" : "Reinigung von Spas und Whirlpools",
      "spa_hot_tub_repairs" : "Reparaturen von Spas und Whirlpools",
      "tile_pool_wall_cleaning" : "Reinigung von Fliesen und Poolwänden",
      "water_testing_balancing" : "Wasserprüfung und -ausgleich",
      "jetted_lap_pools" : "Jet-Sportbecken",
      "pool_construction" : "Poolbau",
      "pool_contractor_commercial_projects" : "Kommerzielle Projekte",
      "pool_contractor_custom_designs" : "Benutzerdefinierte Designs",
      "pool_contractor_other" : "Andere",
      "pool_contractor_renovation" : "Renovierung",
      "pool_contractor_repair_cracks" : "Risse reparieren",
      "pool_contractor_repair_tile" : "Fliese reparieren",
      "pool_contractor_resurfacing" : "Oberflächenerneuerung",
      "pool_contractor_water_features" : "Wassereigenschaften",
      "pool_hot_tub_equipment" : "Pool- und Whirlpool-Geräte",
      "spa_hot_tub_installation" : "Installation von Spas und Whirlpools",
      "bilingual_programs" : "Bilinguale Programme",
      "early_preschool" : "Frühkindliche Vorschule",
      "full_day_preschool" : "Ganztagsvorschule",
      "half_day_preschool" : "Halbtagsvorschule",
      "kindergarten_classes" : "Kindergartenkurse",
      "montessori_programs" : "Montessori-Programme",
      "play_based_preschool" : "Spielbasierte Vorschule",
      "preschool_infant_programs" : "Programme für Säuglinge",
      "preschool_other" : "Andere",
      "reggio_emilia_preschool" : "Reggio Emilia Vorschule",
      "special_needs_programs" : "Programme für besondere Bedürfnisse",
      "summer_camp" : "Sommercamp",
      "waldorf_preschool" : "Waldorf-Vorschule",
      "psychologist_other" : "Andere",
      "buyer_agent" : "Käufervertreter",
      "first_time_home_buyer" : "Erstkäufer eines Eigenheims",
      "foreclosed_properties" : "Zwangsvollstreckte Immobilien",
      "luxury_properties" : "Luxusimmobilien",
      "new_construction" : "Neubau",
      "property_management" : "Immobilienverwaltung",
      "real_estate_agent_other" : "Andere",
      "relocation" : "Standortwechsel",
      "rentals" : "Vermietungen",
      "sellers_agent" : "Händlervertreter",
      "commercial_real_estate" : "Gewerbeimmobilien",
      "easements" : "Dienstbarkeiten",
      "encroachment" : "Eingriff",
      "foreclosure_real_esate_lawyer" : "Zwangsvollstreckung",
      "landlord_tenant_law" : "Vermieter- und Mietrecht",
      "litigation_real_estate_lawyer" : "Rechtsstreitigkeit",
      "mortgage_lending_law" : "Hypotheken- und Kreditrecht",
      "neighbor_hoa_disputes" : "Nachbarschafts- und HOA-Streitigkeiten",
      "property_damage" : "Sachschäden",
      "purchase_agreements" : "Kaufverträge",
      "real_estate_contracts_transactions" : "Immobilientransaktionen",
      "real_estate_lawyer_other" : "Andere",
      "residential_real_estate" : "Wohnimmobilien",
      "title_services" : "Titeldienste",
      "trespassing" : "Hausfriedensbruch",
      "rehab_other" : "Andere",
      "attic_venting" : "Dachbodenbelüftung",
      "gutter_installation" : "Dachrinnenmontage",
      "gutter_repair" : "Dachrinnenreparatur",
      "roof_inspection" : "Dachinspektion",
      "roof_installation" : "Dachinstallation",
      "roof_repair" : "Dachreparatur",
      "roofer_other" : "Andere",
      "skylight_installation" : "Dachfensterinstallation",
      "skylight_repair" : "Dachfensterreparatur",
      "storm_wind_damage_roof_repair" : "Reparatur von Dachschäden",
      "sewage_cleaning" : "Reinigung",
      "sewage_excavation" : "Ausgrabung",
      "sewage_inspection" : "Inspektion",
      "sewage_installation" : "Installation",
      "sewage_locating" : "Lokalisierung",
      "sewage_maintenance_repairs" : "Wartung und Reparaturen",
      "sewage_pro_other" : "Andere",
      "sewage_pumping" : "Pumpen",
      "sewage_removal_demolition" : "Entfernung oder Abriss",
      "remodeling_siding_pro" : "Renovierung",
      "repair_maintenance_siding_pro" : "Reparatur und Wartung",
      "siding_installation" : "Installation von Fassadenverkleidungen",
      "siding_pro_other" : "Andere",
      "siding_removal" : "Entfernung von Fassadenverkleidungen",
      "smart_home_other" : "Andere",
      "commercial_snow_removal" : "Gewerbliche Schneeräumung",
      "residential_plowing" : "Schneeräumung für Wohngebiete",
      "residential_shoveling_blowing" : "Wohnungsreinigung mit Schaufel und Blasgerät",
      "salt_sand_deicing" : "Salz, Sand und Enteisung",
      "snow_relocation" : "Schneeverlegung",
      "snow_removal_other" : "Andere",
      "body_polish" : "Körperpolitur",
      "body_wrap" : "Körperpackung",
      "facial" : "Gesichtsbehandlung",
      "hydrotherapy" : "Hydrotherapie",
      "manicure" : "Maniküre",
      "massage" : "Massage",
      "pedicure" : "Pediküre",
      "peels" : "Peelings",
      "spa_other" : "Andere",
      "spa_packages" : "Spa-Pakete",
      "tanning" : "Bräunung",
      "waxing" : "Waxing",
      "civil_tax_litigation" : "Zivilsteuerstreitigkeiten",
      "corporate_taxes" : "Unternehmenssteuern",
      "criminal_tax_litigation" : "Steuerstrafrechtliche Streitigkeiten",
      "estate_tax_planning" : "Erbschaftssteuerplanung",
      "failure_to_file" : "Fehler beim Einreichen",
      "innocent_spouse_relief" : "Entlastung des unschuldigen Ehepartners",
      "international_tax_services" : "Internationale Steuerdienste",
      "irs_tax_problems" : "IRS Steuerprobleme",
      "non_collectible_status" : "Nicht eintreibbarer Status",
      "offer_in_compromise" : "Angebot im Vergleich",
      "tax_audits" : "Steuerprüfungen",
      "tax_lawyer_other" : "Andere",
      "tax_liens_levies" : "Steuerpfandrechte und -abgaben",
      "tax_planning_lawyer" : "Steuerplanung",
      "tax_relief" : "Steuererleichterung",
      "accounting_support" : "Unterstützung bei der Buchführung",
      "business_incorporation_restructuring" : "Gründung und Umstrukturierung",
      "cryptocurrency_taxes" : "Steuern auf Kryptowährungen",
      "irs_audit_representation" : "Vertretung bei IRS-Prüfungen",
      "irs_filing" : "IRS-Einreichung",
      "irs_problem_consulting" : "IRS-Problemberatung",
      "new_business_services" : "Neue Unternehmensdienste",
      "payroll_support" : "Unterstützung bei der Gehaltsabrechnung",
      "tax_planning_tax_specialist" : "Steuerplanung",
      "tax_preparation" : "Steuervorbereitung",
      "tax_problem_consulting_tax_specialist" : "Beratung bei Steuerproblemen",
      "tax_specialist_other" : "Andere",
      "therapist_other" : "Andere",
      "battery_service" : "Batterieservice",
      "car_towing" : "Abschleppdienst",
      "fuel_delivery" : "Kraftstoffzufuhr",
      "local_hauling" : "Lokaler Transport",
      "long_distance_hauling" : "Lokale Beförderung",
      "motorcycle_towing" : "Motorradabschleppdienst",
      "special_vehicle_towing" : "Abschleppen von Spezialfahrzeugen",
      "tire_change" : "Reifenwechsel",
      "towing_other" : "Andere",
      "case_assessment_traffic_lawyer" : "Fallbewertung",
      "cdl_traffic_ticket" : "Verkehrsverstoß mit einem gewerblichen Führerschein",
      "dui_dwi_traffic_lawyer" : "Fahren unter Alkoholeinfluss",
      "fixit_ticket" : "Verwarnung mit Mängelbescheinigung",
      "parking_ticket" : "Verwarnung wegen Falschparken",
      "reckless_driving_traffic_lawyer" : "Rücksichtsloses Fahren",
      "red_light_ticket" : "Verwarnung wegen Rotlichtverstoß",
      "speeding_ticket" : "Verwarnung wegen Geschwindigkeitsverstoß",
      "suspended_license" : "Führerscheinentzug",
      "traffic_lawyer_other" : "Andere",
      "traffic_ticket" : "Strafzettel",
      "cabling_and_bracing" : "Verkabelung und Verstrebungen",
      "stump_removal" : "Baumstumpfentfernung",
      "tree_planting" : "Baumpflanzung",
      "tree_removal" : "Baumentfernung",
      "tree_service_other" : "Andere",
      "tree_transplanting" : "Baumverpflanzung",
      "tree_trimming_and_pruning" : "Beschneiden und Stutzen von Bäumen",
      "tutor_computer_science" : "Informatik",
      "tutor_foreign_languages" : "Fremdsprachen",
      "tutor_geography" : "Geographie",
      "tutor_government_and_economics" : "Regierung & Wirtschaft",
      "tutor_history" : "Verlauf",
      "tutor_homework_help" : "Hausaufgabenhilfe",
      "tutor_math" : "Mathematik",
      "tutor_other" : "Andere",
      "tutor_reading_and_writing" : "Lesen und Schreiben",
      "tutor_science" : "Wissenschaft",
      "tutor_special_education" : "Sonderpädagogik",
      "tutor_test_pre_college_entrance" : "Prüfungsvorbereitung: Hochschulzugang",
      "tutor_test_prep_grad_school_entrance" : "Prüfungsvorbereitung: Zulassung zur Graduiertenschule",
      "tutor_test_prep_k8" : "Prüfungsvorbereitung: K-8",
      "area_rug_cleaning" : "Reinigung von Teppichböden",
      "drapery_and_blind_cleaning" : "Vorhang- und Jalousienreinigung",
      "leather_cleaning" : "Lederreinigung",
      "mattress_cleaning" : "Matratzenreinigung",
      "upholstery_cleaner_other" : "Andere",
      "upholstery_cleaning" : "Polsterreinigung",
      "upholstery_water_damage_cleanup" : "Wasserschadensbeseitigung",
      "bird_exotic_animal_care" : "Pflege von Vögeln und exotischen Tieren",
      "farm_barn_animal_care" : "Tierpflege auf dem Bauernhof und in Ställen",
      "microchipping" : "Mikrochippen",
      "veterinarian_allergies" : "Allergien",
      "veterinarian_behavior_counseling" : "Verhaltensberatung",
      "veterinarian_dental_care" : "Zahnpflege",
      "veterinarian_dermatology" : "Dermatologie",
      "veterinarian_emergency_care" : "Notfallversorgung",
      "veterinarian_end_of_life_care" : "Palliativpflege",
      "veterinarian_examinations" : "Untersuchungen",
      "veterinarian_nutrition_counseling" : "Ernährungsberatung",
      "veterinarian_other" : "Andere",
      "veterinarian_preventive_care" : "Vorbeugende Pflege",
      "veterinarian_spay_neuter" : "Kastration oder Sterilisation",
      "veterinarian_surgery" : "Chirurgie",
      "veterinarian_vaccinations" : "Impfungen",
      "aerial_videography" : "Luftbild-Videografie",
      "documentary_video_production" : "Produktion von Dokumentarfilmen",
      "family_video_production" : "Familienvideoproduktion",
      "live_streaming" : "Live-Streaming",
      "photography" : "Fotografie",
      "product_demonstrations" : "Produktdemonstration",
      "promotional_video_production" : "Produktion von Werbevideos",
      "real_estate_video_production" : "Produktion von Immobilienvideos",
      "special_event_video_production" : "Produktion von Videos für spezielle Veranstaltungen",
      "video_editing" : "Videobearbeitung",
      "videographer_other" : "Andere",
      "voice_overs" : "Voice-Over",
      "wedding_video_production" : "Hochzeitsvideoproduktion",
      "fire_damage_cleanup_repair" : "Beseitigung/Reparatur von Brandschäden",
      "water_damage_cleanup_repair" : "Wasserschadensbeseitigung",
      "water_damage_flooring" : "Bodenbelag",
      "water_damage_mold_inspection" : "Schimmelinspektion",
      "water_damage_mold_removal" : "Schimmelentfernung",
      "water_damage_other" : "Andere",
      "water_damage_painting" : "Malerei",
      "water_damage_pest_control" : "Schädlingsbekämpfung",
      "water_damage_plumbing" : "Sanitär",
      "water_damage_remodeling" : "Umgestaltung",
      "water_damage_roofing" : "Dachdeckerarbeiten",
      "water_damage_sewage_cleanup" : "Abwasserreinigung",
      "adult_weight_loss_programs" : "Programme zur Gewichtsreduktion für Erwachsene",
      "diet_and_nutrition_counseling" : "Diät- und Ernährungsberatung",
      "kids_weight_loss_programs" : "Programme zur Gewichtsreduktion für Kinder",
      "metabolic_testing" : "Stoffwechseltests",
      "weight_loss_consultation_and_training" : "Beratung und Schulung",
      "weight_loss_fitness_programs" : "Fitnessprogramme",
      "weight_loss_meal_planning" : "Essensplanung",
      "weight_loss_personal_training" : "Persönliches Training",
      "weight_loss_service_other" : "Andere",
      "weight_loss_wellness_programs" : "Wellness-Programme",
      "glass_and_mirror_cleaning" : "Glas- und Spiegelreinigung",
      "gutter_cleaning" : "Dachrinnenreinigung",
      "power_pressure_washing" : "Kraft-/Hochdruckreinigung",
      "rooftop_skylight_cleaning" : "Reinigung von Dächern/Oberlichtern",
      "window_cleaner_other" : "Andere",
      "window_cleaning" : "Fensterreinigung",
      "door_installation" : "Türmontage",
      "door_repair" : "Türreparatur",
      "glass_installation" : "Glasinstallation",
      "window_boardup" : "Boardup",
      "window_installation" : "Fenstermontage",
      "window_repair" : "Fensterreparatur",
      "window_repair_other" : "Andere",
      "install_new_wiper_blades" : "Neue Wischerblätter installieren",
      "repair_power_window" : "Fensterheber reparieren",
      "repair_water_leak" : "Wasserleck reparieren",
      "repair_windshield" : "Windschutzscheibe reparieren",
      "replace_rear_window" : "Heckscheibe ersetzen",
      "replace_side_view_mirrors" : "Seitenspiegel reparieren",
      "replace_side_window" : "Seitenfenster ersetzen",
      "replace_sunroof" : "Schiebedachglas ersetzen",
      "replace_windshield" : "Windschutzscheibe ersetzen",
      "windshield_other" : "Andere",
      "ashtanga" : "Ashtanga",
      "hatha" : "Hatha",
      "hot_yoga" : "Hot Yoga",
      "iyengar" : "Iyengar",
      "kundalini" : "Kundalini",
      "meditation" : "Meditation",
      "power_yoga" : "Power Yoga",
      "restorative" : "Restaurativ",
      "vinyasa" : "Vinyasa",
      "yin" : "Yin",
      "yoga_instructor_other" : "Andere"
    }
  }
}
